import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AnyCatcher } from 'rxjs/internal/AnyCatcher';
import { ConfirmationDialogService } from './../../../confirmation-dialog/confirmation-dialog.service';
import { DocumentService } from './../../../document/document.service';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpService } from './../../../services/http.service';
import { MatterService } from '../../matter.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';
import { ThemePalette } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr';
import { URLUtils } from 'src/app/urlUtils';
import { environment } from 'src/environments/environment';
import flatpickr from 'flatpickr';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { LeavepageComponent } from '../createlegalmatter/leavepage/leavepage.component';
import { GeneralleavepageComponent } from '../../genaralmatter/creategeneralmatter/generalleavepage/generalleavepage.component';
import { catchError, debounceTime, distinctUntilChanged, filter, map, Observable, of, startWith, switchMap, tap, shareReplay } from 'rxjs';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import {  HostListener, AfterViewInit } from '@angular/core';
import { ConfirmDialogComponent } from 'src/app/confirm-dialog/confirm-dialog.component';
import { SuccessDialogComponent } from 'src/app/success-dialog/success-dialog.component';

@Component({
    selector: 'app-viewdetails',
    templateUrl: './viewdetails.component.html',
    styleUrls: ['./viewdetails.component.scss'],
    standalone: false
})
export class ViewDetailsComponent implements OnInit {
  private matterSub?: Subscription;
  private matterInfo$?: Observable<any>;
  private matterInfoId = '';
  private matterInfoAt = 0;
  isSavingItems = false;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  data: any;
  EditDesc = false;
  AddDesc = false;
  notes: any;
  featureName: string = 'Timeline';
  selectedVal: string = ''
  isVisibleInfo: boolean = false;
  clientsList: any;
  selectedMembers: any;
  selectedClients: any;
  selectedCorp: any;
  selectedDocuments: any = [];
  documentsList: any = [];
  searchTextMembers: any = '';
  searchTextClient: any = '';
  searchText: any = '';
  searchDocument: any = '';
  teammembersList: any;
  membersLength: any;
  clientsLength: any;
  isDesc: boolean = false;
  urlSafe: any;
  isNewDocument: boolean = false;
  isMergeEnable: boolean = false;
  selectedMergeDocuments: any = [];
  AddExistingSelected: boolean = false;
  UploadDocSelected: boolean = false;
  files: File[] = [];
  uploadedDocs: any = [];
  DragAndDropView: boolean = true;
  downloadDisabled: boolean = true;
  editMetaFlag: any = true;
  submitted = false;
  editDoc: boolean = false;
  editMetaData: boolean = false;
  selectedIdx: any;
  editMeta: any;
  documentDetail: any = FormGroup;
  values: any = [];
  metaData: any;
  ownerName: any;
  isSaveEnableClient: boolean = true;
  isSaveEnableTM: boolean = true;
  filteredDataDocs: any;
  filteredDataClnts: any;
  filteredDataTms: any;
  isNotesElipses: boolean = false;
  product = environment.product;
  @Input() selectedOption:any;
  corporateList:  any = [];
  isExpanded: boolean = false;
  corpNotes:boolean = false;
  isCorp: boolean = false;
  isLauditor: boolean = false;
  selectedNotes: string = "lauditor";
  notes_list:any = [];
  noteList:any = [];
  historyData1: any;
  historyData:any = [];
  toggleNote = false;
  toggleCorpNote = false;
  selectNote:any
  toggleBool: boolean = true;
  selectedButton :any;
  checked = true;
  disabled = true;
  isChecked: string = 'mainNote' 
  color: ThemePalette = "primary";
  form: any; 
  isReadMore: boolean[] = [];
  isButtonClicked = false;
  encryptDisabled = false;
  allowedFileTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/rtf','text/csv','text/rtf','rtf'];
  docapi = environment.doc2pdf;
  filteredClients:any;
  showCorporateNotes = false;
  clientNamesString: string = '';
  maxVisible: number = 3;
  visibleClients: any[] = [];
  showAllClients: boolean = false;
  sortAscending = true; 
  description:any;
  selectAllClientsChecked:any;
  selectAllMembersChecked:any; 
  noOfDocs: number = 0;
  isDragOver=false;
  selectedTabItem = 'matter-clients';
  matterId:any;
  showUpload=true;   
  showTagInputs: boolean = false;
  currentDocTags: any[] = []; 
  

  //Initializing docUpload Variables
  // reactiveForm: any;
  // keyword = 'name';
  // relationshipSubscribe: any;
  // uploadDocs: any = [];
  // message: any;
  // clientId: any = [];
  // filter: any = "client";
  // groupViewItems: any;
  // groupId: any = [];
  // isSelectGroup: boolean = false;
  // selectedGroupItems: any = [];
  // matterList: any;
  // matters: any;
  // categories:any;
  // selectedValue: any;
  // selectedDate: any;
  // reldata:any[]=[];
  // corpData:any[]=[];
  // selectedmatterType='internal';
  // corp_matter_list:any[] = [];
  // grouplist:any=[];
  // clientdata:any;
   createdBy: any;
   addTag: boolean = false;
   legalMatters: any = [];
   showConfirm = false;
   gro:any;
   activeDocTab: 'Marketplace' | 'Lauditor' = 'Marketplace';
   allDocuments: any[] = [];
   lauditorDocuments: any[] = [];
   marketplaceDocuments: any[] = [];
   isMarketplace=false; 
   loggedUserId: any
   isDisableDoc: boolean = true; 
   allCheck: boolean = false;
   isReadOnly = true
   //activeDocTab: 'Marketplace' | 'Lauditor' = this.isMarketplace ? 'Marketplace' : 'Lauditor';
   today = new Date();
   minDate = new Date(this.today);   // copy of today
   maxDate = new Date(this.today);   // copy of today
   isIndeterminate = false;
   objectKeys = Object.keys;

  //corporateList: any = [];
  @ViewChild(MatAutocompleteTrigger) auto!: MatAutocompleteTrigger;
  originalClientsList: any[] = [];
  selectedEntity = new FormControl("");
  selectedEntityObject = { entityId: "" };
  //filteredEntities: any;
  filteredEntities!: Observable<any[]>;
  emptySearchError: boolean = false;
  currentSearchList: any[] = [];
  reqId: any;
  showTempForm: boolean = false;
  displayMouseOver: boolean = false;
  tooltipgroupslist: any;
  tempList: any = [];
  tempClient: any = FormGroup;
  individualClient: any = FormGroup;
  entityClient: any = FormGroup;
  corporateClient: any = FormGroup;
  filteredData: any;
  inputsubmit: any;
  selectedType: string = 'individual';
  entitysubmitted: boolean = false;
  tempClients: any = [];
  ClientType: string = 'individual';
  CorpType: string = 'corporate';
  csvContent: any = [];
  successModel = false;
  pathName: string = "legalmatter";
  ctype:any;
  searchTermChanged = new Subject<string>();
  role:any;
  docname:any;
  delConfirm = false;
  keyModel: boolean = false;
  catsolo:any;
  mattertype:any;
  expirationDatePickerConfig = {
    dateInputFormat: 'MMM DD, YYYY',
    showWeekNumbers: false,
    showClearButton: true,
    // expiration must be in the future (see futureDateValidator)
    minDate: new Date(new Date().setDate(new Date().getDate() + 1))
};

  // --- Timesheet state ---
  timesheetWeekDays: { label: any; dateLabel: any }[] = [];
  timesheetHeaders: { header1?: any; header2?: any; header3?: any } = {};
  timesheetMembers: any[] = [];
  timesheetWeeklyTotal: any = '0:0';
  timesheetWeekTotalsByDay: { [key: string]: string } = {};

  timesheetCurrentWeek: string = '';   // dd-MM-yyyy, from API
  timesheetPrevWeek: string = '';      // dd-MM-yyyy, from API
  timesheetNextWeek: string = '';      // dd-MM-yyyy, from API
  timesheetIsFrozen: boolean = false;

  // --- Task state ---
  taskWeekStart: any;
  taskWeekEnd: any;
  taskWeekDays: { label: string; date: any; total?: number }[] = [];
  taskMembers: any[] = [];
  taskWeeklyTotal: number = 0;

  showMoreMenu = false;
  tmData: any;

  // optional: close the menu if the user clicks anywhere outside it
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.moreDropdownWrap')) {
      this.showMoreMenu = false;
    }
  }
  // --- Add/Edit Timesheet modal state ---
  showAddTimesheetModal = false;
  tsModalMode: 'add' | 'view' | 'edit' = 'add';
  addTsSubmitted = false;
  addTimesheetForm!: FormGroup;
  tsTasks: any[] = [];
  tsHoursOptions = [
    { name: 'Billable', returnValue: 'billable' },
    { name: 'Non Billable', returnValue: 'non-billable' }
  ];
  tsMinutesOptions = [
    { name: '00', returnValue: '00' },
    { name: '15', returnValue: '15' },
    { name: '30', returnValue: '30' },
    { name: '45', returnValue: '45' }
  ];
  tsEditingTaskId: any = null;
  private tsSelectableDays: { label: any; dateLabel: any }[] = [];
  private tsSelectableDaysKey = '';
  tmUserName: any;

  //Event routing 
  showEventPopup: boolean = false;
  selectedEventData: any = null;
  selectedEventType: string = 'meeting';
  popoverTop: number = 150;
  popoverLeft: number = 300;
  matterOwner: any;
  getTask: any;

  constructor(private matterService: MatterService, private httpservice: HttpService,
    private router: Router, private toast: ToastrService,
    private confirmationDialogService: ConfirmationDialogService,
    private sanitizer: DomSanitizer,
    private docService: DocumentService,private route: ActivatedRoute,
    private fb: FormBuilder,private dialog: MatDialog,
    private spinnerService: NgxSpinnerService) {
  }

  ngOnInit() {
    // Build the timesheet form first so it always exists for add/edit handlers
    this.addTimesheetForm = this.fb.group({
      //matter_type: [''],
      matter_type: [{ value: this.data?.title, disabled: true }],
      title: ['', Validators.required],
      billing: ['', Validators.required],
      date: ['', Validators.required],
      duration_hours: ['00', Validators.required],
      duration_minutes: ['00']
    });

    const currentMatterId = localStorage.getItem('currentMatterId');
    const savedMatterId = localStorage.getItem('activeMatterTabId');
    const savedTab = localStorage.getItem('activeMatterTab') || 'Timeline';
    const savedSubTab = localStorage.getItem('activeMatterSubTab');

    if (savedMatterId && savedMatterId === currentMatterId) {
      this.featureName = savedTab; // Same matter as before (i.e. this is a refresh) — restore where the user was
      if (savedTab === 'T&C' && savedSubTab) {
        this.selectedVal = savedSubTab;
      }
    }
    else {
      this.featureName = 'Timeline'; // Different matter (fresh navigation from the list) — always start on Timeline
      this.selectedVal = '';
      localStorage.removeItem('activeMatterSubTab');
    }

    this.ownerName = localStorage.getItem('name');
    this.loggedUserId = localStorage.getItem('user_id') || '';
    this.role = localStorage.getItem("role") //get roles
    this.catsolo = localStorage.getItem('category');
    this.mattertype = localStorage.getItem('mattertype')

    this.form = this.fb.group({
      notes: ['', Validators.required] 
    });

    // Single subscription for the component; countries and history are each fetched once below
    this.matterSub = this.matterService.editLegalMatterObservable.subscribe((result: any) => {
      if (result) {
        this.data = result;
        this.matterOwner = this.data.owner.name;
        this.getTmData();
        // console.log('matterServiceData:', this.data);
        // console.log('matterOwner:', this.matterOwner);
      }
      this.updateCorporateNotesVisibility();
    });

    // load from API (works on refresh)
    // let id = localStorage.getItem('currentMatterId');
    // if (id) {
    //   const args = { id: id, offset: new Date().getTimezoneOffset() };
    //   this.httpservice.sendGetRequest(URLUtils.getLegalMatterviewDetail(args)).subscribe((res: any) => {
    //     if (res.error === false) {
    //       this.data = res || this.data; // depending on API
    //       this.historyData = res.history;
    //       this.notes_list = res.history?.notes_list;
    //       this.matterOwner = this.data.owner.name;
    //       this.historyData.forEach((res: any) => {
    //       });

    //       // keep service in sync
    //       this.matterService.setLegalMatter(this.data);

    //       // if (this.selectedVal === 'TM' || this.selectedVal === 'Clients') {
    //       //   this.onFeatureClick('T&C');
    //       // }
    //       // if (this.selectedVal === 'Document') {
    //       //   this.onFeatureClick('Document');
    //       // }
    //       if (this.featureName === 'T&C') {
    //         this.onFeatureClick('T&C');
    //       } else if (this.featureName === 'Document') {
    //         this.onFeatureClick('Document');
    //       } else if (this.featureName === 'Timesheets') {
    //         this.onFeatureClick('Timesheets');
    //       }
    //       // else {
    //       //   this.onFeatureClick('Document');
    //       // }
    //     }
    //   });

    //   //const queryParams = { "fields": "clients,corporate,members" }
    //   this.getMatterInfo().subscribe(
    //     (res: any) => {
    //       console.log('--getMatterInfo res:', res);
    //       if (res.error === false) {
    //         // keep the type/groups the list page supplied; the API response has neither
    //         this.data = {
    //           ...this.data,
    //           ...res.matter,
    //           type: this.data?.type ?? localStorage.getItem('mattertype'),
    //           groups: this.data?.groups ?? res.matter?.groups,
    //           id: res.matter?.id ?? this.data?.id ?? id
    //         };
    //         //console.log('--matt data', this.data)

    //         // keep service in sync
    //         this.matterService.setLegalMatter(this.data);
    //         this.updateCorporateNotesVisibility(); // to show corp notes

    //         // if (this.selectedVal === 'TM' || this.selectedVal === 'Clients') {
    //         //   this.onFeatureClick('T&C');
    //         // }
    //         // if (this.selectedVal === 'Document') {
    //         //   this.onFeatureClick('Document');
    //         // }
    //         if (this.featureName === 'T&C') {
    //           this.onFeatureClick('T&C');
    //         } else if (this.featureName === 'Document') {
    //           this.onFeatureClick('Document');
    //         } else if (this.featureName === 'Timesheets') {
    //           this.onFeatureClick('Timesheets');
    //         }
    //       }
    //   })
    // }
    let id = localStorage.getItem('currentMatterId');
    if (id) {
      const args = {
        id: id,
        offset: new Date().getTimezoneOffset()
      };

      // First get the complete matter detail
      this.httpservice
        .sendGetRequest(URLUtils.getLegalMatterviewDetail(args))
        .pipe(switchMap((detailRes: any) => {
            console.log('--- Matter Detail Response ---', detailRes);

            if (detailRes?.error === true) {
              return of(null);
            }

            // Keep existing history functionality
            this.historyData = detailRes?.history || [];
            this.notes_list = detailRes?.history?.notes_list || [];

            // Store detail response temporarily
            const detailData = detailRes;

            // IMPORTANT:
            // Get matter info only AFTER detail API completes
            return this.getMatterInfo().pipe(
              map((infoRes: any) => ({
                detailData,
                infoRes
              }))
            );
          })
        ).subscribe({
          next: (result: any) => {
            if (!result) {
              return;
            }
            const detailData = result.detailData;
            const infoRes = result.infoRes;

            console.log('--- Matter Info Response ---', infoRes);
            if (infoRes?.error === false) {

              // Merge both API responses only after BOTH are available
              this.data = {
                ...detailData,
                ...infoRes.matter,

                // Keep existing values from list/detail
                type: detailData?.type ?? localStorage.getItem('mattertype'),

                groups: detailData?.groups ?? infoRes.matter?.groups,

                id: infoRes.matter?.id ?? detailData?.id ?? id
              };

            } else {

              // If matter info fails, still retain detail response
              this.data = detailData;
            }

            console.log('--- FINAL MATTER DATA ---', this.data);

            this.matterOwner = this.data?.owner?.name || '';

            // Keep service in sync AFTER complete data is available
            this.matterService.setLegalMatter(this.data);

            // Existing functionality
            this.updateCorporateNotesVisibility();

            // Existing tab restoration
            if (this.featureName === 'T&C') {

              this.onFeatureClick('T&C');

            } else if (this.featureName === 'Document') {

              this.onFeatureClick('Document');

            } else if (this.featureName === 'Timesheets') {

              this.onFeatureClick('Timesheets');

            }
          },

          error: (error) => {
            console.error('Failed to load matter details:', error);
          }

        });
    }

    this.documentDetail = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      date_of_filling: ['',this.futureDateValidator.bind(this)]
    });


    this.getCorporateData();
    //this.gethistoryData();
    //this.onFeatureClick('T&C');
    
    //this.getClientsData();
    this.updateCorporateNotesVisibility();
    this.addvalue();
    this.getTmData();

    this.getCountry();
    let tmClient: any = localStorage.getItem('tempClients');
    tmClient = JSON.parse(tmClient);
    if (tmClient != "null")
      this.tempClients = tmClient?.length > 0 ? tmClient : [];

    this.tempClient = this.fb.group({
      name: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      confirmemail: ['', [Validators.required, Validators.email]],
      country: ['', Validators.required],
      phonenumber: [''],
      type: ['individual', Validators.required]
    }, { validator: this.emailMatchValidator() });

    //this.getClients();
    this.entityClient = this.fb.group({
      fullname: ['', Validators.required],
      contact_person: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      confirmemail: ['', [Validators.required, Validators.email]],
      country: ['', Validators.required],
      phonenumber: [''],
    }, { validator: this.emailMatchValidator() });

  
    // get search clients
    // this.filteredEntities = this.selectedEntity.valueChanges.pipe(
    //   debounceTime(300),
    //   map(value => value?.trim()),
    //   distinctUntilChanged(),
    //   switchMap(value => {
    //     // Empty val
    //     if (!value) {
    //       this.showTempForm = false;
    //       this.currentSearchList = [];
    //       return of([]);
    //     }
    //     return this.searchClients(value); // ONLY call API when user types
    //   })
    // );
    this.filteredEntities = this.selectedEntity.valueChanges.pipe(
      debounceTime(300),
      map(value => value?.trim() || ''),
      distinctUntilChanged(),
      switchMap(value => {
        this.searchText = value;

        if (!value) {
          this.showTempForm = false;
          this.currentSearchList = [];
          return of([]);
        }

        return this.searchClients(value);
      })
    );

    // console.log('selectedEntity', this.selectedEntity);
    // console.log('searchText', this.searchText);
    // console.log('currentSearchList', this.currentSearchList);
    // console.log('filteredEntities', this.filteredEntities);

    //this.initTimesheetWeek();
    this.initTaskWeek();
    this.loadTimesheetData();
  
  }

  private parseDDMMYYYY(dateStr: string): Date {
    const [dd, mm, yyyy] = dateStr.split('-').map(Number);
    return new Date(yyyy, mm - 1, dd);
  }

  private todayAsDDMMYYYY(): string {
    const d = new Date();
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  private getMonday(d: Date): Date {
    const date = new Date(d);
    const day = date.getDay();
    const diff = date.getDate() - day + (day === 0 ? -6 : 1);
    return new Date(date.setFullYear(date.getFullYear(), date.getMonth(), diff));
  }

  isDurationEmpty(): boolean {
    const hours = Number(this.addTimesheetForm.value.duration_hours) || 0;
    const minutes = Number(this.addTimesheetForm.value.duration_minutes) || 0;
    return hours === 0 && minutes === 0;
  }

  // initTimesheetWeek() {
  //   const monday = this.getMonday(new Date());
  //   this.timesheetWeekStart = monday;
  //   this.timesheetWeekEnd = new Date(monday);
  //   this.timesheetWeekEnd.setDate(monday.getDate() + 6);
  //   this.buildTimesheetWeekDays();
  //   this.loadTimesheetData();
  // }

  initTaskWeek() {
    const monday = this.getMonday(new Date());
    this.taskWeekStart = monday;
    this.taskWeekEnd = new Date(monday);
    this.taskWeekEnd.setDate(monday.getDate() + 6);
    this.buildTaskWeekDays();
    this.loadTaskData();
  }

  // buildTimesheetWeekDays() {
  //   const dayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  //   const days: { label: string; date: Date }[] = [];
  //   for (let i = 0; i < 7; i++) {
  //     const date = new Date(this.timesheetWeekStart);
  //     date.setDate(date.getDate() + i);
  //     days.push({ label: dayLabels[i], date });
  //   }
  //   this.timesheetWeekDays = days;
  // }

  buildTaskWeekDays() {
    const dayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    const days: { label: string; date: Date; total?: number }[] = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(this.taskWeekStart);
      date.setDate(date.getDate() + i);
      days.push({ label: dayLabels[i], date, total: 0 });
    }
    this.taskWeekDays = days;
  }

  onWeekChange(direction: 'prev' | 'next', type: 'timesheet' | 'task') {
    if (type === 'timesheet') {
      const target = direction === 'prev' ? this.timesheetPrevWeek : this.timesheetNextWeek;
      this.loadTimesheetData(target);
    } else {
      // keep your existing Tasks logic as-is for now
      const days = direction === 'prev' ? -7 : 7;
      this.taskWeekStart = new Date(this.taskWeekStart.setDate(this.taskWeekStart.getDate() + days));
      this.taskWeekEnd = new Date(this.taskWeekEnd.setDate(this.taskWeekEnd.getDate() + days));
      this.buildTaskWeekDays();
      this.loadTaskData();
    }
  }

  onWeekToday(type: 'timesheet' | 'task') {
    if (type === 'timesheet') {
      this.loadTimesheetData(this.todayAsDDMMYYYY());
    } else {
      this.initTaskWeek();
    }
  }


  openWeekPicker(type: 'timesheet' | 'task') {
    // hook up a date-range picker if needed
  }

  parseHeaderDate(label: string): Date {
    return new Date(label);
  }

  /**
   * Accepts the date shapes the APIs hand us ("Sep 23, 2025", an ISO string,
   * "23-09-2025") and returns midnight local time, so days compare cleanly.
   */
  private parseDayStart(value: any): Date | null {
    if (!value) return null;
    const date = (typeof value === 'string' && /^\d{2}-\d{2}-\d{4}$/.test(value))
      ? this.parseDDMMYYYY(value)
      : new Date(value);
    if (isNaN(date.getTime())) return null;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  /** The day the matter was created; timesheets cannot be logged before it. */
  private matterCreatedDate(): Date | null {
    return this.parseDayStart(
      this.tmData?.matter?.createdDate || this.data?.created_date || this.data?.created_on
    );
  }

  isTimesheetDayAllowed(dateLabel: any): boolean {
    const created = this.matterCreatedDate();
    const day = this.parseDayStart(dateLabel);
    if (!created || !day) return true;
    return day.getTime() >= created.getTime();
  }

  /**
   * The week grid always shows Mon-Sun, but only the days on/after the matter's
   * creation date can be logged against. Memoised so *ngFor keeps its identity.
   */
  get selectableTimesheetDays(): { label: any; dateLabel: any }[] {
    const created = this.matterCreatedDate();
    const current = this.addTimesheetForm?.get('date')?.value || '';
    const key = this.timesheetWeekDays.map(d => d.dateLabel).join('|')
      + '#' + (created ? created.getTime() : '') + '#' + current;
    if (key !== this.tsSelectableDaysKey) {
      this.tsSelectableDaysKey = key;
      this.tsSelectableDays = this.timesheetWeekDays
        .filter(d => this.isTimesheetDayAllowed(d.dateLabel) || d.dateLabel === current);
    }
    return this.tsSelectableDays;
  }

  onAddTimesheet() {
    this.tsModalMode = 'add';
    this.tsEditingTaskId = null;
    this.addTsSubmitted = false;

    const defaultDate = this.timesheetWeekDays?.[0]?.dateLabel
      ? this.parseHeaderDate(this.timesheetWeekDays[0].dateLabel)
      : new Date();

    this.addTimesheetForm.reset({
      matter_type: this.data?.title,
      title: '',
      billing: '',
      date: '',
      duration_hours: '00',
      duration_minutes: '00'
    });

    this.loadTsTasks();
    this.showAddTimesheetModal = true;
  }

  switchToEditMode() {
    // console.log('tsEditingTaskId',this.tsEditingTaskId)
    // console.log('data: ',this.data)
    this.tsModalMode = 'edit';
    this.addTsSubmitted = false;
  }

  addTimesheet(member: any, task: any, dayKey: string) {
    //console.log('addTimesheet called with:', { member, task, dayKey });
    const dateLabel = this.timesheetWeekDays.find(d => d.label === dayKey)?.dateLabel || '';
    if (!this.isTimesheetDayAllowed(dateLabel)) return;

    this.tsModalMode = 'add';
    this.tsEditingTaskId = null;
    this.addTsSubmitted = false;

    this.addTimesheetForm.reset({
      matter_type: this.data?.title,
      title: task?.taskName || '',
      billing: '',
      date: dateLabel,
      duration_hours: '00',
      duration_minutes: '00'
    });

    this.loadTsTasks();
    this.showAddTimesheetModal = true;
  }

  viewTimesheet(member: any, task: any, dayKey: string) {
    console.log('viewTimesheet called with:', { member, task, dayKey });
    const dayData = task[dayKey];
    this.getTask = dayData;   // holds isLinkedWithCalendar

    this.tsModalMode = 'view';
    this.tsEditingTaskId = dayData?.taskId || null;
    this.addTsSubmitted = false;
    this.tmUserName = member?.userName || '';

    const dateLabel = this.timesheetWeekDays.find(d => d.label === dayKey)?.dateLabel || '';

    this.addTimesheetForm.patchValue({
      matter_type: this.data?.title,
      title: task.taskName,
      billing: task.billing || '',
      date: dateLabel,
      duration_hours: dayData?.hours ?? '00',
      duration_minutes: dayData?.minutes ?? '00'
    });

    this.loadTsTasks();
    this.showAddTimesheetModal = true;
  }


  closeAddTimesheetModal() {
    this.showAddTimesheetModal = false;
    this.addTimesheetForm.reset();
    this.addTsSubmitted = false;
    this.getTask = null;
  }

  loadTsTasks() {
    // confirm this matches your getTasksDetails contract for a matter's task list
    this.httpservice.sendGetRequest(URLUtils.getTasksDetails('legal')).subscribe((res: any) => {
      this.tsTasks = res?.tasks || [];
    });
  }

  // onSubmitAddTimesheet() {
  //   this.addTsSubmitted = true;
  //   if (this.addTimesheetForm.invalid) return;

  //   const raw = this.addTimesheetForm.value;

  //   // New entries only: an existing entry dated before the matter was created
  //   // (legacy data) must stay editable.
  //   if (this.tsModalMode !== 'edit' && !this.isTimesheetDayAllowed(raw.date)) {
  //     this.toast.error('Timesheets cannot be logged before the matter was created.');
  //     return;
  //   }

  //   const payload: any = {
  //     title: raw.title,
  //     billing: raw.billing,
  //     date: new Date(raw.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
  //     duration_hours: raw.duration_hours || '00',
  //     duration_minutes: raw.duration_minutes || '00',
  //     action: 'hours',
  //     matter_id: this.data?.id,
  //     matter_type: 'legal'
  //   };

  //   if (this.tsModalMode === 'edit' && this.tsEditingTaskId) {
  //     payload.id = this.tsEditingTaskId;
  //     this.httpservice.sendPutRequest(URLUtils.getTimeSheets, payload).subscribe((res: any) => {
  //       this.toast.success(res.msg);
  //       this.loadTimesheetData();
  //       this.closeAddTimesheetModal();
  //     });
  //   } else {
  //     this.httpservice.sendPostRequest(URLUtils.getTimeSheets, payload).subscribe((res: any) => {
  //       if (!res.error) {
  //         this.toast.success(res.msg);
  //         this.loadTimesheetData();
  //         this.closeAddTimesheetModal();
  //       } else {
  //         this.toast.error(res.msg);
  //       }
  //     });
  //   }
  // }

  onSubmitAddTimesheet() {
    this.addTsSubmitted = true;
    if (this.addTimesheetForm.invalid) return;

    const raw = this.addTimesheetForm.value;

    if (this.tsModalMode !== 'edit' && !this.isTimesheetDayAllowed(raw.date)) {
      this.toast.error('Timesheets cannot be logged before the matter was created.');
      return;
    }

    const payload: any = {
      title: raw.title,
      billing: raw.billing,
      date: new Date(raw.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      duration_hours: raw.duration_hours || '00',
      duration_minutes: raw.duration_minutes || '00',
      action: 'hours',
      matter_id: this.data?.id,
      matter_type: 'legal'
    };

    if (this.tsModalMode === 'edit' && this.tsEditingTaskId) {
      payload.id = this.tsEditingTaskId;

      // Timesheet was created from a calendar event → ask which record(s) to update
      if (this.getTask?.isLinkedWithCalendar === true) {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: '400px',
          disableClose: true,
          hasBackdrop: true,
          backdropClass: 'backdropBackground',
          data: {
            title: 'Confirmation',
            message: `This timesheet has an associated event entry.`,
            sub: `Do you want to update the event too?`,
            confirmText: `Update Both`,
            cancelText: `Update Timesheet Only`
          }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          payload.timesheet_update_scope = result ? 'UPDATE_BOTH' : 'UPDATE_TIMESHEET_ONLY';
          this.updateTimesheet(payload);
        });
        return;
      }

      this.updateTimesheet(payload);
    } else {
      this.httpservice.sendPostRequest(URLUtils.getTimeSheets, payload).subscribe((res: any) => {
        if (!res.error) {
          this.toast.success(res.msg);
          this.loadTimesheetData();
          this.closeAddTimesheetModal();
        } else {
          this.toast.error(res.msg);
        }
      });
    }
  }

  private updateTimesheet(payload: any) {
    this.httpservice.sendPutRequest(URLUtils.getTimeSheets, payload).subscribe((res: any) => {
      if (!res.error) {
        this.toast.success(res.msg);
        this.loadTimesheetData();
        this.closeAddTimesheetModal();
      } else {
        this.toast.error(res.msg);
      }
    });
  }

  deleteTimesheetEntry(day: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Confirmation', message: 'Are you sure you want to delete this timesheet?' }
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed) {
        this.httpservice.sendDeleteRequestwithObj(URLUtils.getTimeSheets, { id: day.taskId }).subscribe((res: any) => {
          this.toast.success(res.msg);
          this.loadTimesheetData();
        });
      }
    });
  }


  onAddTask() {
    // navigate to / open your Add Task form
  }

  viewTasks(member: any, day: any) {
    // navigate to / open task detail for that member+day
  }

  addTask(member: any, day: any) {
    // navigate to / open Add Task pre-filled for member+day
  }

  loadTimesheetData(weekDate?: string) {
    const matterId = this.getCurrentMatterId();
    if (!matterId) return;
    const dateParam = weekDate || this.timesheetCurrentWeek || this.todayAsDDMMYYYY();

    this.spinnerService.show();
    this.httpservice
      .sendGetRequest(URLUtils.getMatterTimesheet('legal', matterId, dateParam))
      .subscribe((res: any) => {
        this.spinnerService.hide();
        this.tmData = res;

        this.timesheetIsFrozen = res?.dates?.isFrozen;
        this.timesheetCurrentWeek = res?.dates?.currentWeek;
        this.timesheetPrevWeek = res?.dates?.prevWeek;
        this.timesheetNextWeek = res?.dates?.nextWeek;

        const headers = res?.timesheetList?.headers || {};
        this.timesheetHeaders = {
          header1: headers.header1,
          header2: headers.header2,
          header3: headers.header3
        };

        const dayKeys = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
        this.timesheetWeekDays = dayKeys
          .filter(key => headers[key])
          .map(key => ({ label: key, dateLabel: headers[key] }));

        this.timesheetMembers = res?.timesheetList?.teamMembers || [];
        this.timesheetWeekTotalsByDay = res?.timesheetList?.weekTotal || {};
        this.timesheetWeeklyTotal = res?.timesheetList?.weekTotal?.wTotal || '0:0';
      });
  }

  formatDuration(day: any): string {
    const h = day?.hours || 0;
    const m = day?.minutes || 0;
    if (!h && !m) return '';
    return `${h}:${String(m).padStart(2, '0')}`;
  }

  // "1:5" -> "1:05"
  formatTotal(val: any): string {
    if (val === null || val === undefined || val === '') return '';
    const [h, m = '0'] = String(val).split(':');
    return `${h}:${m.padStart(2, '0')}`;
  }

  getCurrentMatterId(): string | null {
    return this.data?.id || localStorage.getItem('currentMatterId');
  }

  /**
   * Shared matter-info request. Several callers need this response while the page is
   * loading; without this they each fired their own copy of the same GET.
   */
  /** Loads the Team Member(s) / Client(s) lists from the server. */
  loadTeamAndClients(forceReload = false) {
    this.getMatterInfo(forceReload).subscribe((res: any) => {
      const matter = res?.matter;
      //console.log('loadTeamAndClients matter:', matter);
      if (!matter) return;

      this.membersLength = matter.members.length;
      this.selectedClients = matter.clients;
      this.selectedCorp = matter.corporate;
      this.selectedMembers = matter.members;
      this.clientsLength = matter.clients.length;

      this.selectedVal == 'Clients' ? this.getClientsData() : this.getTmData();
    });
  }

  getMatterInfo(forceReload = false): Observable<any> {
    const id = this.getCurrentMatterId();
    if (!id) return of(null);

    const reusable = !forceReload && this.matterInfo$ && this.matterInfoId === id
      && Date.now() - this.matterInfoAt < 1500;

    if (!reusable) {
      this.matterInfoId = id;
      this.matterInfoAt = Date.now();
      this.matterInfo$ = this.httpservice
        .sendGetRequest(URLUtils.getLegalMatterInfoDetails(id))
        .pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.matterInfo$!;
  }


  // A task can have a billable and a non-billable row; they come back
  // adjacent, so the first row spans the task cell and the rest skip it.
  taskRowspan(tasks: any[], i: number): number {
    const name = tasks[i]?.taskName;
    if (i > 0 && tasks[i - 1]?.taskName === name) return 0;
    let span = 1;
    while (tasks[i + span]?.taskName === name) span++;
    return span;
  }

  getInitials(name: string): string {
    if (!name) return '';
    return name.trim().split(/\s+/).map(p => p[0]).slice(0, 1).join('').toUpperCase();
  }

  loadTaskData() {
    // TODO: replace with your real task endpoint — same pattern as above
    this.taskMembers = this.taskMembers || [];
    this.taskWeekDays.forEach(day => {
      day.total = this.taskMembers.reduce((sum: number, m: any) => {
        const entry = m.days?.find((d: any) => new Date(d.date).toDateString() === day.date.toDateString());
        return sum + (entry?.count || 0);
      }, 0);
    });
    this.taskWeeklyTotal = this.taskWeekDays.reduce((sum, d) => sum + (d.total || 0), 0);
  }

  futureDateValidator(control: any) {
    if (!control.value) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selected = new Date(control.value);
    selected.setHours(0, 0, 0, 0);

    return selected <= today ? { notFutureDate: true } : null;
  }

  //Event routings
  openEventPopup(evt: MouseEvent, item: any) {
    if (!item?.id) return;

    this.selectedEventData = { id: item.id };
    this.selectedEventType = 'meeting';

    // position near the click, matching how the calendar grid does it
    this.popoverTop = evt.clientY;
    this.popoverLeft = evt.clientX;

    this.showEventPopup = true;
  }

  // Back to the matter list
  goBack() {
    this.router.navigate(['/matter/legalmatter/view']);
  }

  closeEventPopup() {
    this.showEventPopup = false;
    this.selectedEventData = null;
  }

  onTimelineEventDeleted() {
    this.gethistoryData();
  }
 
  getCountry() {
    this.httpservice.sendGetRequest(URLUtils.getCountry).subscribe((res: any) => {
      res.data.countries.forEach((item: any) => {
        // console.log("item is "+JSON.stringify(item[0]));
        this.csvContent.push(item[0]);
      })
      this.csvContent.shift();
      //console.log("csvContent",this.csvContent);
    });
  }

  searchClients(searchText: any): Observable<any[]> {
    const payload = { search: searchText || '' };

    return this.httpservice.sendPostRequest(URLUtils.searchClient, payload).pipe(
      map((res: any) => {
        let clientList = res?.clients || [];

        const filteredList = clientList.filter((item: any) =>
          !this.selectedClients.some((s: any) => s.id === item.client_id)
        );
        this.currentSearchList = filteredList;

        // Show temp form ONLY if list empty AND input is NOT empty
        //this.showTempForm = filteredList.length === 0 && searchText.trim().length > 0;
        this.showTempForm =
          filteredList.length === 0 &&
          searchText.trim().length > 0 &&
          !this.hasCorporateSelected;

        return filteredList;
      }),
      catchError((err) => {
        console.error(err);

        // If input is empty → don't show temp form
        if (!searchText || searchText.trim() === '') {
          this.showTempForm = false;
        }

        // Must return Observable ALWAYS
        return of([]);
      })
    );
  }

  openPanel() {
    setTimeout(() => {
      if (this.autocompleteTrigger && !this.autocompleteTrigger.panelOpen) {
        this.autocompleteTrigger.openPanel();
      }
    });
  }

  private scrollHandler = (event: Event) => {
    if (!this.autocompleteTrigger?.panelOpen) {
      return;
    }

    const overlayPane = document.querySelector('.cdk-overlay-pane');
    if (overlayPane && overlayPane.contains(event.target as Node)) {
      return;
    } // If scroll happens INSIDE autocomplete panel → ignore

    this.autocompleteTrigger.closePanel(); // Scroll happened outside → close panel
  };

  ngAfterViewInit() {
    document.addEventListener('scroll', this.scrollHandler, true);
  }

  ngOnDestroy() {
    document.removeEventListener('scroll', this.scrollHandler, true);
    this.matterSub?.unsubscribe();
  }
  
  onSearchChange(value: string) {
    this.searchTermChanged.next(value);
  }
    
  preventLeadingSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const isFirstChar = input.selectionStart === 0;
    if (event.key === ' ' && isFirstChar) {
      event.preventDefault(); //prevent space at 1st position
    }
  }

  updateCorporateNotesVisibility() {

    if (!this.data?.id) return; // guard against undefined data

    this.getMatterInfo().subscribe(
      (res: any) => {
        if (!res?.matter) return;

        this.selectedClients = res.matter.clients;
        this.selectedCorp = res.matter.corporate;
        // console.log('sel', this.selectedClients)
        // console.log('sel corp', this.selectedCorp)

        // Combine selectedClients and selectedCorp into one array
        this.filteredClients = this.selectedClients.concat(this.selectedCorp);

        // Get all client names
        // this.clientNamesString = this.filteredClients.map((client: any) => client.name).join(', ');
        // Get the first client's name
        // if (this.filteredClients.length > 0) {
        //   this.clientNamesString = this.filteredClients[0].name;
        // } else {
        //   this.clientNamesString = 'No clients available';
        // }

        this.updateClientNamesString();
        //Show Corporate Notes radio only if there is corporate cli.
        this.showCorporateNotes = this.selectedCorp.some((client: any) => client.type === 'corporate');
      });
  }

  updateClientNamesString() {
    if (this.showAllClients) {
      this.clientNamesString = this.filteredClients.map((client: { name: any; }) => client.name).join(', ');
    } else {
      const limitedClients = this.filteredClients.slice(0, 1);
      this.clientNamesString = limitedClients.map((client: { name: any; }) => client.name).join(', ');
    }
  }

  toggleClientNames() {
    this.showAllClients = !this.showAllClients;
    this.updateClientNamesString();
  }

  sortMembers() {
    const fixedMember = this.selectedMembers[0]; // Extract the first fixed member
    const membersToSort = this.selectedMembers.slice(1); // Members to be sorted

    membersToSort.sort((a: { name: any; }, b: { name: any; }) => {
      if (a.name < b.name) {
        return this.sortAscending ? -1 : 1;
      }
      if (a.name > b.name) {
        return this.sortAscending ? 1 : -1;
      }
      return 0;
    });

    // Reconstruct the array with the fixed member and sorted members
    this.selectedMembers = [fixedMember, ...membersToSort];
    this.sortAscending = !this.sortAscending; // toggle the sorting order
  }
  sortClients() {
    this.selectedClients.sort((a: { name: any; }, b: { name: any; }) => {
      if (a.name < b.name) {
        return this.sortAscending ? -1 : 1;
      }
      if (a.name > b.name) {
        return this.sortAscending ? 1 : -1;
      }
      return 0;
    });
    this.sortAscending = !this.sortAscending; // toggle the sorting order
  }

  onAdd() {
   // this.AddDesc = true;
   this.isButtonClicked = true;
       
   // Set focus on the last added textarea
    setTimeout(() => {
      const textareas = document.querySelectorAll('.row.container.tex');
      const lastTextarea = textareas[textareas.length - 1] as HTMLTextAreaElement;
      if (lastTextarea) {
        lastTextarea.focus();
      }
    });
  }

  onAddCN(item: any) {
    this.isButtonClicked = true;
    //console.log('item', item);
        
    // Set focus on the last added textarea
    setTimeout(() => {
      const textareas = document.querySelectorAll('.row.container.tex');
      const lastTextarea = textareas[textareas.length - 1] as HTMLTextAreaElement;
      if (lastTextarea) {
        lastTextarea.focus();
      }
    });

    const cnId = this.getCurrentMatterId();
    if (!cnId) return;
    const args = { id: cnId, offset: new Date().getTimezoneOffset() };
    this.httpservice.sendGetRequest(URLUtils.getLegalMatterviewDetail(args)).subscribe((res: any) => {
      const matchedItem = res?.history?.find((historyItem: any) => historyItem.id === item.id);
      if (matchedItem) {
        const notesList = matchedItem?.notes_list;
        if (notesList && notesList.length > 0) {
          const lastNote = notesList[notesList.length - 1]?.notes;
          if (lastNote === "5") {
            this.toast.error("Corporate Notes only allow 5 Notes.");
            this.gethistoryData();
            item.notes_list.AddDesc = true; // Prevent further additions
            this.isButtonClicked = false; // Reset the button state
            return;
          }
        }
      }
    });
  }

  eventCheck(event: any) {
    this.toggleNote = event.target.checked;
    // console.log('eve',event.target.checked)
    // console.log('tN', this.toggleNote)
    this.toggleNote = !this.toggleNote;
  }

  gethistoryData(){
    const id = this.getCurrentMatterId();
    if (!id) return;
    const args = { id: id, offset: new Date().getTimezoneOffset() };
    this.httpservice.sendGetRequest(URLUtils.getLegalMatterviewDetail(args)).subscribe((res: any) => {
      if (res && res.error == false) {
        this.historyData = res.history;
        this.notes_list = res.history?.notes_list;
      }
    });
  }

  addNotes(item: any) {
    this.submitted = true;
    item.AddDesc=true
    item.EditDesc=true
    
    // if(this.submitted = true){
    //   this.toast.success('HELLO');
    // }

    if (this.form.valid && this.notes.length > 0) {
      var req = { "notes": this.notes }
      // console.log(item)
      this.httpservice.sendPutRequest(URLUtils.updateEventNotes(item.id), req).subscribe(
        (res: any) => {
          // console.log('itemId',item.id);
          // console.log('idRes',res);
          if (!res.error)
            this.toast.success(res.msg);
          else
            this.toast.error(res.msg);
        });
        item.AddDesc=false
        item.EditDesc=false
    }
  }
  
  addCorpNotes(item: any, notes: any) {
    this.submitted = true;
    item.notes_list.AddDesc = true

    if (this.form.valid && this.notes.length != 0) {
      let req = { "notes": this.notes }
      //console.log(item)
      //console.log('Bef-ITEM', item.notes_list.length);

      if (item.notes_list.length + 1 > 5) {
        this.toast.error("Corporate Notes only allow 5 Notes.");
        return
      }

      this.httpservice.sendPostRequest(URLUtils.updateCorpNotes(item.id), req).subscribe(
        (res: any) => {
          // console.log('itemId',item.id);
          //console.log('ITEM', item);
          if (!res.error) {
            this.toast.success(res.msg);
            item.AddDesc = true
            this.gethistoryData();
          }
          else
            this.toast.error(res.msg);
        });
      item.notes_list.AddDesc = false
    }
  }

  updateCorpNotes(item: any, notes: any) {

    this.submitted = true;
    item.EditDesc = true

    if (this.form.valid && this.notes.length != 0) {
      let req = {
        "notes": this.notes,
        "notes_id": notes.id
      }
      // console.log(item)
      this.httpservice.sendPatchRequest(URLUtils.updateCorpNotes(item.id), req).subscribe(
        (res: any) => {
          if (!res.error)
            this.toast.success(res.msg);
          else
            this.toast.error(res.msg);
          // console.log('itemId',item.id);
          // console.log('idRes',res);
        },
        (error: HttpErrorResponse) => {
          if (error.status === 400 || error.status === 401 || error.status === 403) {
            //this.notes = !this.notes
            this.gethistoryData();
            const errorMessage = error.error.msg || 'Unauthorized';
            this.toast.error(errorMessage);
            //console.log(error);
          }
        });
      item.EditDesc = false
    }
  }

  deleteNotes(item:any,notes:any) {
    //this.selectNote = note;
    // console.log('item',item)
    // console.log('notesId',notes.id)
    let data = {
      'notes_id': notes.id,
      //'notes_id': this.notes_list?.id,
    }
    this.confirmationDialogService.confirm('Confirmation', ' Are you sure! Do you want to Delete this note?!', true, 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.httpservice.sendDeleteRequestwithObj(URLUtils.deleteCorpNotes(item.id),data).subscribe((res: any) => {
            if (!res.error) {
              if (confirmed) {
                this.toast.success(res.msg);
                this.gethistoryData();
              }
              else {
                this.toast.error(res.msg);
              }
            }
          },
          (error: HttpErrorResponse) => {
            if (error.status === 400 || error.status === 401 || error.status === 403) {
              const errorMessage = error.error.msg || 'Unauthorized';
              this.toast.error(errorMessage);
              //console.log(error);
            }
          }
          );
        }
      })
  }

  //main notes
  toggleNotesEllipsis(item: any) {
    //console.log('iii',item)
    item.isNotesElipses = !item.isNotesElipses;
  }

  //corp Notes
  // toggleReadMore(index: number) {
  //   this.isReadMore[index] = !this.isReadMore[index];
  // }

  toggleReadMore(note: any,index:any) {
    note.isReadMore = !note.isReadMore;
    this.isReadMore[index] = !this.isReadMore[index];
  }

  get f() {
    return this.documentDetail.controls;
  }
  removevalue(i: any) {
    this.values.splice(i, 1);
  }

  addvalue() {
    this.values.push({ tagtype: "", tag: "" });
  }
  submit() {
    //Check each item in the values
    for (const item of this.values) {
        if (!item.tag.trim() || !item.tagtype.trim()) {
            this.toast.error('Please fill all fields');
            return;
        }
    } 
    this.noOfDocs = 0
    this.editMetaFlag = true;
    //console.log(JSON.stringify(this.values));
    let resultObj: any = {};

    this.values.forEach((item: any) => {
      resultObj[item.tagtype] = item.tag

    });
    this.metaData = resultObj; 
    this.addTag = false;
    //console.log("tagsArray  " + JSON.stringify(resultObj));
  }
  matterInfoEdit() {
    //this.matterService.editLegalMatter(this.data);
    //console.log('id',this.data)
    this.httpservice.sendGetRequest(URLUtils.getLegalMatterInfoDetails(this.data?.id)).subscribe((res: any) => {
      const legal = { ...res.matter, type: this.data?.type, groups:this.data?.groups, id:this.data?.id };
      this.matterService.editLegalMatter(legal);
    })
    //this.router.navigate(['/matter/legalmatter/matterEdit'])
    this.router.navigate(['/matter/legalmatter/edit/'+this.data.id])
  }
    
  checkSelectAllTM() {
    // Check if all teammembersList members exist in selectedMembers
    this.selectAllMembersChecked = this.teammembersList.length > 0 &&
      this.teammembersList.every((tm: any) =>
        this.selectedMembers.some((sm: any) => sm.id === tm.id)
      );
  }
  checkSelectAllClient() {
    // Check if all clientsList members exist in selectedClients
    this.selectAllClientsChecked = this.clientsList.length > 0 &&
      this.clientsList.every((tm: any) =>
        this.selectedClients.some((sm: any) => sm.id === tm.id)
      );
  }
  onFeatureClick(val: string, tab?: 'Marketplace' | 'Lauditor') {
    this.featureName = val;
    //this.isAddItem = this.featureName == 'Timeline' ? false : this.isAddItem;
    localStorage.setItem('activeMatterTab', val); // persist
    localStorage.setItem('activeMatterTabId', localStorage.getItem('currentMatterId') || ''); // tie tab to this matter

    if (this.featureName == 'T&C') {
      this.loadTeamAndClients();
    }
    else {
      // Leaving Team Member(s)/Client(s) entirely — clear so those buttons stop showing active
      this.selectedVal = '';
      localStorage.removeItem('activeMatterSubTab');
    }
    if (this.featureName == 'Document') {
    const is_marketplace_string = localStorage.getItem("is_marketplace");
    this.isMarketplace = is_marketplace_string === 'true';
    this.activeDocTab = this.isMarketplace ? 'Marketplace' : 'Lauditor';

      if (tab) {
        this.activeDocTab = tab;
      }

      // this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(this.data.id)).subscribe(
      //   (res: any) => {
      //     this.selectedDocuments = res.documents;
      //   });

      this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(this.data?.id)).subscribe(
        (res: any) => {
          // if (res) {
             
          this.selectedDocuments = res.documents;
          //   this.createdBy = localStorage.getItem('name');
          //   if (this.isMergeEnable)
          //     this.getMergeDocuments();
          //   else
          //     this.getDocuments();
          // }
          // console.log('OG SelectedDocuments', this.selectedDocuments)
          if (res) {
            this.lauditorDocuments = res.documents || [];
            this.marketplaceDocuments = res.ext_doc || [];
            // this.marketplaceDocuments = (res.ext_doc || []).map((doc: any) => ({
            //   ...doc,
            //   description: '',
            //   created: '',
            //   addedBy: 'Marketplace',
            //   viewUrl: doc.url,
            // }));

            this.setSelectedDocuments(); // Call tab logic
            this.createdBy = localStorage.getItem('name');
            // if (this.isMergeEnable)
            //   this.getMergeDocuments();
            // else
            //   this.getDocuments();
          }
      });
    }

    if (this.featureName == 'Timesheets') {
      this.loadTimesheetData(this.timesheetCurrentWeek);
    }
    if (this.featureName == 'Tasks') {
      this.loadTaskData();
    }
    //this.isVisibleInfo=!this.isVisibleInfo;
  }

    
  onFeatureAddNewDoc(val: string, tab?: 'Lauditor' | 'Marketplace') {
    this.featureName = val;

    if (this.featureName == 'Document') {
      this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(this.data.id)).subscribe(
        (res: any) => {
          this.selectedDocuments = res.documents;
        });
    }
  }

  setSelectedDocuments() {
      this.selectedDocuments =
      this.activeDocTab === 'Marketplace'
        ? this.marketplaceDocuments
        : this.lauditorDocuments;
  }

  UploadCancel() {
    this.DragAndDropView = true;
    this.uploadedDocs = [];
    this.files=[];
    this.showUpload=true; //show upload btn
    
    //this.onFeatureAddNewDoc('Document');
    // this.isNewDocument= !this.isNewDocument;
    // this.AddExistingSelected = false;
    // this.UploadDocSelected=false; 
    //this.showUpload=true;             
  }

  saveDocuments() {
    //console.log('document',this.selectedDocuments)

    this.httpservice.sendPutRequest(URLUtils.legalHistoryDocumentsUpdate(this.data.id),{
        documents: (this.selectedDocuments).map((doc: any) => ({
          docid: doc.docid,
          doctype: doc.doctype,
          user_id: doc.user_id
        }))
      }).subscribe(
        (res: any) => {
        this.isNewDocument = false;
        this.UploadCancel();
        this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(this.data.id)).subscribe(
          (res: any) => {
            if (res) {
              this.selectedDocuments = res.documents;
              this.createdBy = localStorage.getItem('name');
              // if (this.isMergeEnable)
              //   this.getMergeDocuments();
              // else
              //   this.getDocuments();
            }
          });
          
          if (this.isMarketplace === true) {
            this.onFeatureClick('Document', 'Marketplace')
          }

      },
      (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
          //console.log(error);
        }
      });
  }

  onClick(val: string) {
    this.selectedVal = val;
    localStorage.setItem('activeMatterSubTab', val);
    localStorage.setItem('activeMatterTabId', localStorage.getItem('currentMatterId') || '');
    //console.log('s-val',this.selectedVal)
    //this.selectedNotes = val;
    this.selectedTabItem == 'matter-clients'; //show client ui
        
    // clear for if temp form open
    this.showTempForm = false;
    this.searchText = '';
  }
  getTmData() {
  //  console.log('getTmData called');
  //  console.log('data', this.data);
    // if (!this.data?.groups) {
    //   return; // not ready yet, bail out safely
    // }
    let grps = this.data.groups.map((obj: any) => obj.id);
    let clients = this.data.clients
    let corporate = this.data.corporate


    var payload
    if (this.product == 'corporate') {
      payload = { 'group_acls': grps, 'attachment_type': 'members' }
    }
    else {
      if (this.data.corporate.length > 0)
        payload = { 'group_acls': grps, 'clients': corporate, 'attachment_type': 'members' }
      else
        payload = { 'group_acls': grps, 'clients': clients, 'attachment_type': 'members' }
    }

    if (this.product == 'corporate') {
      this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements, payload).subscribe(
        (res: any) => {
          this.teammembersList = res['members'];
          // console.log('members',this.teammembersList)
          // console.log('selectedMembers', this.selectedMembers)
          this.checkSelectAllTM(); //update selectAll
          let index = this.teammembersList.findIndex((d: any) => d.name === this.ownerName); //find index in your array
          //this.teammembersList.splice(index, 1); 
          this.teammembersList = this.teammembersList.filter((el: any) => {
            return !(this.selectedMembers ?? []).find((element: any) => {
              return element.id === el.id;
            });
          });
        });
    }
    else {
      if (this.role === 'GH') {
        let gh = { module: "matter" };
        this.httpservice.sendGetRequest(URLUtils.getMembers, gh).subscribe((res: any) => {
          // this.teammembersList = res.data.users;
            this.teammembersList = res.data.users.filter((user: any) =>
            !user.groups?.some(
              (grp: any) => grp.name === 'SuperUser' || grp.name === 'AAM'
            )
          );
          // console.log('members',this.teammembersList)
          // console.log('selectedMembers', this.selectedMembers)
          this.checkSelectAllTM(); //update selectAll
          let index = this.teammembersList.findIndex((d: any) => d.name === this.ownerName); //find index in your array
          //this.teammembersList.splice(index, 1); 
          this.teammembersList = this.teammembersList.filter((el: any) => {
            return !(this.selectedMembers ?? []).find((element: any) => {
              return element.id === el.id;
            });
          });
        });
      }
      else {
        this.httpservice.sendGetRequest(URLUtils.getMembers).subscribe((res: any) => {
          //this.teammembersList = res.data.users;
          this.teammembersList = res.data.users.filter((user: any) =>
            !user.groups?.some(
              (grp: any) => grp.name === 'SuperUser' || grp.name === 'AAM'
            )
          );

          // console.log('members',this.teammembersList)
          // console.log('selectedMembers', this.selectedMembers)
          this.checkSelectAllTM(); //update selectAll
          let index = this.teammembersList.findIndex((d: any) => d.name === this.ownerName); //find index in your array
          //this.teammembersList.splice(index, 1); 
          this.teammembersList = this.teammembersList.filter((el: any) => {
            return !(this.selectedMembers ?? []).find((element: any) => {
              return element.id === el.id;
            });
          });
        });
      }
    }
  }
  // getClientsData() {
  //   let grps = this.data.groups?.map((obj: any) => obj.id);
  //   this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements,
  //     { 'group_acls': grps, 'attachment_type': 'clients' }).subscribe(
  //       (res: any) => {
  //         this.clientsList = res['clients'];
  //         this.clientsList = this.clientsList.filter((el: any) => {
  //           return !this.selectedClients.find((element: any) => {
  //             return element.id === el.id;
  //           });
  //         });
  //       });
  // }

  getClientsData() {
    // console.log('selectedClients',this.selectedClients)
    // console.log('selcorp',this.selectedCorp)
    //this.selectedTabItem == 'matter-clients';

    let grps = this.data?.groups?.map((obj: any) => obj.id);
    var payload
    if (this.product === 'corporate') {
      payload = { 'group_acls': grps, 'attachment_type': 'corporate', 'product': 'corporate' }
    }
    else {
      payload = { 'group_acls': grps, 'attachment_type': 'clients' }
    }
    // console.log('payload',payload)

    // combine the responses - only for lauditor product
    if (this.product !== 'corporate') {
      let observables: any;

      if (this.data?.corporate?.length>0) {
        observables = {
          clientList: this.httpservice.getFeaturesdata(URLUtils.getAllRelationship)
        };
      } else {
        observables = {
          corpList: this.httpservice.getFeaturesdata(URLUtils.getCalenderExternal)
        };
      }
      forkJoin(observables).subscribe((res: any) => {
        const clientList = res?.clientList;
        const corpList = res?.corpList;
        // console.log('clientList', clientList)
        // console.log('corpList', corpList)

        const clientLists = (clientList?.data?.relationships || []).map((m: any) => ({
          id: m.id,
          name: m.name,
          type: m.type
        }));

        const corpLists = (corpList?.relationships || []).map((m: any) => ({
          id: m.id,
          name: m.name,
          type: 'corporate'
        }));

        // Combine both
        let combinedList = [...clientLists, ...corpLists];

        // Remove selected clients and corp
        if (this.selectedClients?.length || this.selectedCorp?.length) {
          const selectedIds = [
            ...(this.selectedClients || []).map((c: any) => c.id),
            ...(this.selectedCorp || []).map((c: any) => c.id)
          ];

          combinedList = combinedList.filter((item: any) => !selectedIds.includes(item.id));
        }

        this.clientsList = combinedList;
        //console.log('Filtered clientsList', this.clientsList);
      });

      if (this.product == 'corporate') {
        this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements, payload).subscribe(
          (res: any) => {
            if (this.product == 'corporate') {
              this.clientsList = res['corporate'];
            }
            else {
              this.clientsList = res['clients'];
            }
            this.checkSelectAllClient(); //update selectAll

            if (this.selectedClients && this.selectedClients.length > 0) {
              this.clientsList = this.clientsList.filter((el: any) => {
                return !this.selectedClients.find((element: any) => {
                  return element.id === el.id;
                });
              });
            };
          }) //getting grp bases list
      }
      else {
//get clients lists
      }

    }
    else {
      this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements, payload).subscribe(
        (res: any) => {
          if (this.product == 'corporate') {
            this.clientsList = res['corporate'];
          }
          else {
            this.clientsList = res['clients'];
          }
          this.checkSelectAllClient(); //update selectAll
          // console.log('cl',this.clientsList)
          // console.log('selectedClients',this.selectedClients)
          // console.log('selectedCorp',this.selectedCorp)

          if (this.selectedClients && this.selectedClients.length > 0) {
            this.clientsList = this.clientsList.filter((el: any) => {
              return !this.selectedClients.find((element: any) => {
                return element.id === el.id;
              });
            });
          };
        })
    }
  }        

  getCorporateData(){
    let grps = this.data?.groups?.map((obj: any) => obj.id);
    //console.log('grps',grps)
    this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements,
      { 'group_acls': grps, 'attachment_type': 'corporate', 'product': 'corporate' }
      ).subscribe(
          (res: any) => {
                 this.corporateList = res?.corporate || [];
                  if(this.selectedClients && this.selectedClients.length > 0){
                    this.corporateList = this.corporateList.filter((el: any) => {
                      return !this.selectedClients.find((element: any) => {
                        return element.id === el.id;
                      });
                    });

                  }
          })
  }

  selectTeammember(group: any) {
    this.isSaveEnableTM = false;
    // new array references: the `filter` pipe is pure and ignores in-place changes
    this.selectedMembers = [...this.selectedMembers, group];
    this.teammembersList = this.teammembersList.filter((d: any) => d.id !== group.id);
    if (this.teammembersList.length == 0) {
      let checkbox = document.getElementById('selectAllMembers') as HTMLInputElement | null;
      if (checkbox != null)
        checkbox.checked = true;
    }
  }
  selectClient(group: any) {
    this.isSaveEnableClient = false;
    this.selectedClients = [...this.selectedClients, group];
    this.clientsList = this.clientsList.filter((d: any) => d.id !== group.id);
    if (this.clientsList.length == 0) {
      let checkbox = document.getElementById('selectAllClients') as HTMLInputElement | null;
      if (checkbox != null)
        checkbox.checked = true;
    }
  }
  selectCorporate(group: any, value?: any) {
    this.selectedClients.push(group);
    let index = this.corporateList.findIndex((d: any) => d.id === group.id); //find index in your array
    this.corporateList.splice(index, 1);
    if (this.corporateList.length == 0) {
        let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
        if (checkbox != null)
            checkbox.checked = true;
    }
    //console.log("Corp selected clients "+JSON.stringify(this.selectedClients));
}

  // selectAllMembers(event: any) {
  //   this.isSaveEnableTM = false;

  //   if (event?.target?.checked) {
  //     if (this.teammembersList?.length > 0) {
  //       if (this.filteredDataTms?.length > 0) {
  //         this.selectedMembers = this.selectedMembers.concat(this.filteredDataTms);
  //         this.teammembersList = this.teammembersList.filter((el: any) => {
  //           return !this.selectedMembers.find((element: any) => {
  //             return element.id === el.id;
  //           });
  //         });
  //       }
  //       else {
  //         this.selectedMembers = this.selectedMembers.concat(this.teammembersList);
  //         this.teammembersList = [];
  //       }
  //     }
  //   } else {
  //     this.teammembersList = this.selectedMembers.concat(this.teammembersList);
  //     this.selectedMembers = [];
  //   }
  // }
  selectAllMembers(event: any) {
    this.isSaveEnableTM = false;

    if (event?.target?.checked) {
      let membersToAdd = [];

      if (this.filteredDataTms?.length > 0) {
        membersToAdd = this.filteredDataTms;
      } else if (this.teammembersList?.length > 0) {
        membersToAdd = this.teammembersList;
      }

      // Merge unique members, excluding duplicates
      const allUnique = [...this.selectedMembers];
      membersToAdd.forEach((member: any) => {
        if (!allUnique.some((m: any) => m.id === member.id)) {
          allUnique.push(member);
        }
      });

      this.selectedMembers = allUnique;
      this.teammembersList = this.teammembersList.filter(
        (el: any) => !this.selectedMembers.some((sel: any) => sel.id === el.id)
      );
    } else {
      // Deselect all, but KEEP loggedUserId
      this.teammembersList = [
        ...this.teammembersList,
        ...this.selectedMembers.filter((m: any) => m.id !== this.loggedUserId),
      ];
      this.selectedMembers = this.selectedMembers.filter(
        (m: any) => m.id === this.loggedUserId
      );
    }
  }
  
  selectAllClients(event: any) {
    this.isSaveEnableClient = false;
    if (event?.target?.checked) {
      if (this.clientsList?.length > 0) {
        if (this.filteredDataClnts?.length > 0) {
          this.selectedClients = this.selectedClients.concat(this.filteredDataClnts);
          this.clientsList = this.clientsList.filter((el: any) => {
            return !this.selectedClients.find((element: any) => {
              return element.id === el.id;
            });
          });
        }
        else {
          this.selectedClients = this.selectedClients.concat(this.clientsList);
          this.clientsList = [];
        }
      }
    } else {
      this.clientsList = this.selectedClients.concat(this.clientsList);
      this.selectedClients = [];
      this.onFeatureClick('T&C');
    }
  }

  removeTeammember(group: any) {
    this.isSaveEnableTM = false;
    //this.showConfirm = true;
    this.gro = group
    // this.confirmationDialogService.confirm('Alert', 'Are you sure you want to remove access for ' + group.name + ' ?', true, 'Yes', 'No')
    //   .then((confirmed) => {
    //     if (!confirmed) {
    //       let index = this.selectedMembers.findIndex((d: any) => d.id === group.id); //find index in your array
    //       this.selectedMembers.splice(index, 1);
    //       //console.log('sms',this.selectedMembers)
    //       this.teammembersList.push(group);
    //       //console.log('tm',this.teammembersList)
    //       if (this.selectedMembers.length == 0 || this.teammembersList.length == 1) {
    //         let checkbox = document.getElementById('selectAllMembers') as HTMLInputElement | null;
    //         if (checkbox != null)
    //           checkbox.checked = false;
    //       }
    //     }
    //   })

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Confirmation', message: `Are you sure you want to remove access for ${group.name}?` }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      //console.log('Dialog result:', result);
      if (result) {
        this.deleMem();
      }
    });
  }

  deleMem(){
        let index = this.selectedMembers.findIndex((d: any) => d.id === this.gro.id); //find index in your array
        this.selectedMembers.splice(index, 1);
        this.teammembersList.push(this.gro);
        if (this.selectedMembers.length == 0 || this.teammembersList.length == 1) {
          let checkbox = document.getElementById('selectAllMembers') as HTMLInputElement | null;
          if (checkbox != null)
            checkbox.checked = false;
        }
        this.showConfirm = false;
  }
  
  removeClient(group: any) {
    // console.log('selectedClients',this.selectedClients)
    // console.log('selectedCorp',this.selectedCorp)

    this.isSaveEnableClient = false;
    // this.confirmationDialogService.confirm('Alert', 'Are you sure you want to remove access for ' + group.name + ' ?', true, 'Yes', 'No')
    //   .then((confirmed) => {
    //     if (confirmed) {
    //       let index = this.selectedClients.findIndex((d: any) => d.id === group.id); //find index in your array
    //       this.selectedClients.splice(index, 1);
    //       this.clientsList.push(group);
    //       if (this.selectedClients.length == 0 || this.clientsList.length == 1) {
    //         let checkbox = document.getElementById('selectAllClients') as HTMLInputElement | null;
    //         if (checkbox != null)
    //           checkbox.checked = false;
    //       }
    //     }
    //   })

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Confirmation', message: `Are you sure you want to remove access for ${group.name}?` }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      //console.log('Dialog result:', result);
      if (result) {
        let index = this.selectedClients.findIndex((d: any) => d.id === group.id); //find index in your array
        this.selectedClients.splice(index, 1);
        this.clientsList.push(group);
        if (this.selectedClients.length == 0 || this.clientsList.length == 1) {
          let checkbox = document.getElementById('selectAllClients') as HTMLInputElement | null;
          if (checkbox != null)
            checkbox.checked = false;
        }
      }
    });

  }
  removeCorp(group: any) {
    //console.log('ggg',group)
    this.ctype = group;
    // console.log('selectedClients', this.selectedClients)
    // console.log('selectedCorp', this.selectedCorp)

    this.isSaveEnableClient = false;
    // this.confirmationDialogService.confirm('Alert', 'Are you sure you want to remove access for ' + group.name + ' ?', true, 'Yes', 'No')
    //   .then((confirmed) => {
    //     if (confirmed) {
    //       let index = this.selectedCorp.findIndex((d: any) => d.id === group.id); //find index in your array
    //       this.selectedCorp.splice(index, 1);
    //       this.clientsList.push(group);
    //       if (this.selectedCorp.length == 0 || this.clientsList.length == 1) {
    //         let checkbox = document.getElementById('selectAllClients') as HTMLInputElement | null;
    //         if (checkbox != null)
    //           checkbox.checked = false;
    //       }
    //     }
    //   })

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Confirmation', message: `Are you sure you want to remove access for ${group.name}?` }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      //console.log('Dialog result:', result);
      if (result) {
        let index = this.selectedCorp.findIndex((d: any) => d.id === group.id); //find index in your array
        this.selectedCorp.splice(index, 1);
        this.clientsList.push(group);
        if (this.selectedCorp.length == 0 || this.clientsList.length == 1) {
          let checkbox = document.getElementById('selectAllClients') as HTMLInputElement | null;
          if (checkbox != null)
            checkbox.checked = false;
        }
      }
    });
  }
  
  deleteMainNotes(item: any) {
    var req = { "delete_notes": true }
  this.httpservice.sendPutRequest(
    URLUtils.updateEventNotes(item.id),req
  ).subscribe(
    (res: any) => {
      if (!res.error) {
        this.toast.success(res.msg);

        // Clear note from UI
        item.notes = '';
        item.AddDesc = false;
        item.EditDesc = false;
      } else {
        this.toast.error(res.msg);
      }
    }
  );
}



  documentDelete(document: any) {
    this.docname = document;
    // console.log('del document', document)
    // console.log('gro', this.gro)
    // console.log('data', this.data)
    // console.log('selectedDocuments', this.selectedDocuments)
    // console.log('delDoc(docname)',this.docname)

    if (this.data.clients.length === 0 || this.data.corporate.length === 0) {
      this.delConfirm = true;
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: { title: 'Confirmation', message: ` Are you sure you want to delete ${this.docname.name} document?` }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
              this.delDoc(this.docname);
            }
        });
      return
    }

    let index = this.selectedDocuments.findIndex((d: any) => d.docid === document.docid);
    this.selectedDocuments.splice(index, 1);
    this.httpservice.sendPutRequest(URLUtils.legalHistoryDocumentsUpdate(this.data?.id), { "documents": this.selectedDocuments }).subscribe(
      (res: any) => {
        //console.log(res);
      });
  }

  delDoc(val: any) {
    // console.log('delval',val)

    let selectedId: any = [];
    selectedId.push(val.docid)
    let documentId: any = {
      docids: selectedId
    };
    this.httpservice.sendPostRequest(URLUtils.deleteDocument, documentId).subscribe((res: any) => {
      //console.log("res" + res);
      if (!res.error) {
        this.delConfirm = false;
        this.dialog.open(SuccessDialogComponent, {
          width: '400px',
          data: {
            title: 'Success',
            message: res.msg,
            confirmText: 'OK',
            cancelText: ''
          }
        });
        // this.confirmationDialogService.confirm('Success', `${res.msg}`, false, 'OK', '', true, 'sm', true, false);
        this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(this.data?.id)).subscribe(
          (res: any) => {
            this.selectedDocuments = res.documents;
          });
      }
      else {
        this.toast.error(res.msg)
      }
    },
      (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
          //console.log(error);
        }
      });
  }

  saveItems(val: any) {
    if (this.isSavingItems) return; // ignore repeat clicks while the save is in flight
    this.isSavingItems = true;
    // console.log('val',val)
    // console.log('selectedClients',this.selectedClients)
    // console.log('selectedCorp',this.selectedCorp)
    // console.log('selectedMembers',this.selectedMembers)
    // console.log('ctype',this.ctype)

    // selectedClients array
     this.selectedClients = this.selectedClients || [];
    // if (this.selectedCorp) {
    //   this.selectedClients.push(Array.isArray(this.selectedCorp) ? this.selectedCorp[0] : this.selectedCorp);
    // }

    // Only push selectedCorp if it is not null or undefined
    if (this.selectedCorp && this.selectedCorp !== null) {
      const corpToAdd = Array.isArray(this.selectedCorp) ? this.selectedCorp[0] : this.selectedCorp;
      if (corpToAdd) {
        this.selectedClients.push(corpToAdd);
      }
    }
    // Remove any null values from selectedClients
    this.selectedClients = this.selectedClients.filter((client: any) => client !== null && client !== undefined);

   
    let data: any = {}; //payload

    let tms = this.selectedMembers.filter((element: any) => element)
      .map((c: any) => ({
        id: c.id
      })); // teamMems

    let corporateId = this.selectedClients.find((c: any) => c.type === 'corporate')?.id ?? null;  // Get corporate ID
    //console.log('corp', corporateId)
    if (corporateId) {
      this.isSaveEnableClient = true;
    }
    // const hasCorporate = this.selectedClients.some(
    //   (c: any) => c.type === 'corporate'
    // );
    // console.log('hassccc', hasCorporate)
    
    let client = this.selectedClients.filter((element: any) => element)
      .map((c: any) => ({
        id: c.id,
        type: c.type
      })); // Clients

    if (val === 'members') {
      data.members = tms
    }
    // else if (corporateId) {
    //   data.corporate = corporateId;
    // }
    else {
      data.corporate = corporateId;
      data.clients = client;
    }
    

    this.httpservice.sendPatchRequest(URLUtils.patchLegalMatter(this.data?.id), data).subscribe(
      (res: any) => {
        this.isSavingItems = false;
        if(res.error === true){
          this.toast.error(res.msg)
          return;
        }
        else{
        //this.onFeatureClick('T&C');
        if(val === 'members'){
          this.toast.success('Team Members list updated successfully.')
          //this.confirmationDialogService.confirm('Success', 'Team Members list updated successfully.', false,  'OK', '', true, 'sm',true, false);
          this.selectAllMembersChecked = this.selectedMembers.length === this.selectedMembers.length;
          this.selectAllClientsChecked = this.selectedClients.length !== this.selectedClients.length;
          // let checkbox = document.getElementById('selectAllMembers') as HTMLInputElement | null;
          //   if (checkbox != null){
          //     checkbox.checked = false;
          //   }
        }
        else if(val === 'clients'){
          this.toast.success('Clients list updated successfully.')
          //this.confirmationDialogService.confirm('Success', 'Clients list updated successfully.', false, 'OK', '', true, 'sm',true, false);
          this.selectAllClientsChecked = this.selectedClients.length === this.selectedClients.length;
          this.selectAllMembersChecked = this.selectedMembers.length !== this.selectedMembers.length;
          // let checkbox = document.getElementById('selectAllClients') as HTMLInputElement | null;
          // if (checkbox != null){
          //   checkbox.checked = false;
          // }
        }
        else{}
        this.loadTeamAndClients(true); // show what the server now has
        }
      },
      (error: HttpErrorResponse) => {
        this.isSavingItems = false;
        if (error.status === 400 || error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
          //console.log(error);
        }
      }
    )
  }
  cancelItems() {
    this.searchTextMembers = '';
    this.isSaveEnableTM = true;
    this.isSaveEnableClient = true;
    this.loadTeamAndClients(true); // discard the unsaved selection
    let checkbox = (document.getElementById('selectAllMembers') as HTMLInputElement | null || document.getElementById('selectAllClients') as HTMLInputElement | null);
    if (checkbox != null){
      checkbox.checked = false;
    }
  }
  sort(property: any, docsShared: any) {
    let docs = docsShared;
    this.isDesc = !this.isDesc; //change the direction    
    // this.column = property;
    let direction = this.isDesc ? 1 : -1;

    docs.sort(function (a: any, b: any) {
      if (a[property] < b[property]) {
        return -1 * direction;
      }
      else if (a[property] > b[property]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  };
  viewDocument(item: any) {
    //console.log(item)
        
    if (item.added_encryption) {
      var body = new FormData();
      body.append('docid', item.docid)
      body.append('shared_doc', true.toString())
      let url = environment.apiUrl + URLUtils.decryptFile
      this.httpservice.sendPostDecryptRequest(url, body).subscribe((res: any) => {
        const blob = new Blob([res], { type: item.contentType });
        const url = URL.createObjectURL(blob);
        if (this.allowedFileTypes.includes(item.contentType)) {
          let fdata = new FormData();
          fdata.append('file', blob);
          this.httpservice.sendPostDecryptRequest(environment.DOC2FILE, fdata).subscribe((ans: any) => {
            const ansBlob = new Blob([ans], { type: 'application/pdf' });
            const ansUrl = URL.createObjectURL(ansBlob);
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(ansUrl)
            let obj = {
              'isIframe': true,
              'url': this.urlSafe
            }
            this.confirmationDialogService.confirm('View', obj, true, "Ok", "Close", false, "lg");
          })
        } else {
          this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          let obj = {
            'isIframe': true,
            'url': this.urlSafe
          }
          this.confirmationDialogService.confirm('View', obj, true, "Ok", "Close", false, "lg");
        }
      })
    }
    else if (item.added_encryption == false) {
      let id = { 'id': item.docid }

      this.httpservice.sendGetRequest(URLUtils.viewDocuments(id)).subscribe((res: any) => {
        if (this.allowedFileTypes.includes(item.contentType)) {
          this.spinnerService.show()
          this.httpservice.sendPostDocRequest(this.docapi, { 'url': res.data.url }).subscribe((ans: any) => {
            const blob = new Blob([ans], { type: 'application/pdf' });
            // Create a URL for the Blob
            const url = URL.createObjectURL(blob);
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(url)
            let obj = {
              'isIframe': true,
              'url': this.urlSafe
            }
            this.confirmationDialogService.confirm('View', obj, true, "Ok", "Close", false, "lg");
            this.spinnerService.hide()
          })
        }
        else {
          if (res && res.data && !res.error) {
            this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
            let obj = {
              'isIframe': true,
              'url': this.urlSafe
            }
            this.confirmationDialogService.confirm('View', obj, true, "Ok", "Close", false, "lg");
          }
          else {
            alert(res.msg)
          }
        }

        //console.log(" this.view    " + JSON.stringify(this.documents));
      });
    }
    else {
      let id = { 'id': item.docid };
      this.spinnerService.show();

      this.httpservice.sendGetRequest(URLUtils.viewDocuments(id)).subscribe((res: any) => {
        const fileUrl = res.data.url; // Directly use the pre-signed PDF URL
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl); // Sanitize it for iframe

        const obj = {
          isIframe: true,
          url: this.urlSafe
        };
        this.confirmationDialogService.confirm('View', obj, true, 'Ok', 'Close', false, 'lg');

        this.spinnerService.hide();
      });
    }
  }
  getMergeDocuments() {
    this.httpservice.sendGetRequest(URLUtils.getClientPdfDocuments).subscribe(
      (res: any) => {
        //console.log(res);
        if (!res['error'] && res['docs']?.length > 0) {
          this.documentsList = res['docs'];
          this.selectedDocuments = this.documentsList.filter((el: any) => {
            return this.selectedDocuments?.find((element: any) => {
              return element.docid === el.id;
            });
          });
        }
      })
  }
  getDocuments() {
    var clients: string | any[] = []
    let grps = this.data.groups.map((obj:any) => obj.id);
     clients = this.data.clients.map((obj:any) => obj.id);
    if (this.data.corporate.length > 0) {
      clients = clients.concat(this.data.corporate.map((obj:any) => obj.id));
    }
    // let clients: any[] = [];
    // if (Array.isArray(this.data?.clients)) {
    //   clients = this.data.clients.map((obj: any) => obj.id);
    // }
    // if (Array.isArray(this.data?.corporate) && this.data.corporate.length > 0) {
    //   clients = clients.concat(this.data.corporate.map((obj: any) => obj.id));
    // }

    //if (this.product == 'corporate') {
    this.httpservice.sendPutRequest(URLUtils.getFilterTypeAttachements,
      {  'attachment_type': 'documents','clients':clients }).subscribe(
        (res: any) => {
          if (!res['error'] && res['documents']?.length > 0) {
            this.documentsList = res['documents'];
            this.documentsList = this.documentsList.filter((el: any) => {
              return !this.selectedDocuments.find((element: any) => {
                return element.docid === el.docid;
              });
            });
          }
        })
   // }
  }
  selectDocument(doc: any) {
    this.selectedDocuments.push(doc);
    let index = this.documentsList.findIndex((d: any) => d.docid === doc.docid); //find index in your array
    this.documentsList.splice(index, 1);
    if (this.documentsList.length == 0) {
      let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
      if (checkbox != null)
        checkbox.checked = true;
    }
  }
  removeDocument(doc: any) {
    let index = this.selectedDocuments.findIndex((d: any) => d.docid === doc.docid); //find index in your array
    this.selectedDocuments.splice(index, 1);
    this.documentsList.push(doc);
    if (this.selectedDocuments.length == 0 || this.documentsList.length == 1) {
      let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
      if (checkbox != null)
        checkbox.checked = false;
    }
  }
  selectAll(event: any) {
    if (event?.target?.checked) {
      if (this.documentsList?.length > 0) {
        if (this.filteredDataDocs?.length > 0) {
          this.selectedDocuments = this.selectedDocuments.concat(this.filteredDataDocs);
          this.documentsList = this.documentsList.filter((el: any) => {
            return !this.selectedDocuments.find((element: any) => {
              return element.docid === el.docid;
            });
          });
        }
        else {
          this.selectedDocuments = this.selectedDocuments.concat(this.documentsList);
          this.documentsList = [];
        }
      }
    } else {
      this.documentsList = this.selectedDocuments.concat(this.documentsList);
      this.selectedDocuments = [];
    }
  }
  // saveDocuments() {
  //   console.log('document',this.selectedDocuments)

  //   this.httpservice.sendPutRequest(URLUtils.legalHistoryDocumentsUpdate(this.data.id),{
  //       documents: (this.selectedDocuments).map((doc: any) => ({
  //         docid: doc.docid,
  //         doctype: doc.doctype,
  //         user_id: doc.user_id
  //       }))
  //     }).subscribe(
  //       (res: any) => {
  //       this.isNewDocument = false;
  //       this.httpservice.sendGetRequest(URLUtils.legalHistoryDocuments(this.data.id)).subscribe(
  //         (res: any) => {
  //           if (res) {
  //             this.selectedDocuments = res.documents;
  //             this.createdBy = localStorage.getItem('name');
  //             if (this.isMergeEnable)
  //               this.getMergeDocuments();
  //             else
  //               this.getDocuments();
  //           }
  //         });
  //         this.onFeatureClick('Document','Marketplace')

  //     },
  //     (error: HttpErrorResponse) => {
  //       if (error.status === 401 || error.status === 403) {
  //         const errorMessage = error.error.msg || 'Unauthorized';
  //         this.toast.error(errorMessage);
  //         //console.log(error);
  //       }
  //     });
  // }
  cancelDocuments() {
    this.confirmationDialogService.confirm('Confirmation', 'Changes you made may not be saved. Do you want to continue?', true, 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.onFeatureClick('Document');
          this.isNewDocument = false;
        }
      })
  }
  
  onMergeClick() {
    this.onFeatureClick('Document');
  }
  selectMergeDocument(event: any, doc: any) {
    if (event) {
      this.selectedMergeDocuments.push(doc);
      if (this.selectedMergeDocuments.length == this.selectedDocuments.length) {
        let checkbox = document.getElementById('mergeSelectAll') as HTMLInputElement | null;
        if (checkbox != null)
          checkbox.checked = true;
      }
    } else {
      let index = this.selectedMergeDocuments.findIndex((d: any) => d.docid === doc.docid); //find index in your array
      this.selectedMergeDocuments.splice(index, 1);
      if (this.selectedMergeDocuments.length == 0) {
        let checkbox = document.getElementById('mergeSelectAll') as HTMLInputElement | null;
        if (checkbox != null)
          checkbox.checked = false;
      }
    }
  }
  CheckAllOptions(event: any) {
    this.selectedDocuments.forEach((val: any) => { val.checked = event });
    event ? this.selectedMergeDocuments = [...this.selectedDocuments] : this.selectedMergeDocuments = [];
  }
  mergeDoc() {
    localStorage.setItem("selectedDocs", JSON.stringify(this.selectedMergeDocuments));
    this.docService.setData(this.selectedMergeDocuments);
    this.docService.updateDocData(this.selectedMergeDocuments);
    this.router.navigate(['documents/pdfmergedoc/client']);
  }
  public dropped(files: NgxFileDropEntry[]) {
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
           this.files.push(file);
          //console.log(droppedFile.relativePath, file);
          this.uploadedDocs.push(file);
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        //console.log(droppedFile.relativePath, fileEntry);
      }
    }
  }


  // public handleFileInput(event: Event | { target: { files: FileList } }) {
  //   const input = (event as any).target as HTMLInputElement;
  //   if (input && input.files) {
  //     for (let i = 0; i < input.files.length; i++) {
  //       const file = input.files[i];

  //       let allowedTypes = ['image/png', 'image/heif', 'image/webp', 'image/ico', 'image/jpg', 'image/jpeg', 'image/arw', 'image/bmp', 'image/svg', 'image/tiff', 
  //       'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 
  //       'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel', 
  //       'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/rtf', 'text/csv', 'text/rtf', 'text/plain'];

  //       // Check if the file type is allowed
  //       if (allowedTypes.includes(file.type)) {
  //         this.files.push(file);
  //         this.uploadedDocs.push(file);
  //       } else {
  //         this.toast.error('Invalid file format!');
  //       }
  //     }
  //   }
  // }

  // onDragOver(event: DragEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.isDragOver = true;
  // }

  // onDragLeave(event: DragEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.isDragOver = false;
  // }

  // onDrop(event: DragEvent) {
  //   event.preventDefault();
  //   event.stopPropagation();
  //   this.isDragOver = false;

  //   if (event.dataTransfer && event.dataTransfer.files.length > 0) {
  //     const fakeEvent = { target: { files: event.dataTransfer.files } };
  //     this.handleFileInput(fakeEvent);
  //     event.dataTransfer.clearData();
  //   }
  // }

  handleFiles(files: FileList) {
    let allowedTypes = ['image/png', 'image/heif', 'image/webp', 'image/ico', 'image/jpg', 'image/jpeg', 'image/arw', 'image/bmp', 'image/svg', 'image/tiff', 
        'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel', 
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/rtf', 'text/csv', 'text/rtf', 'text/plain'];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (allowedTypes.includes(file.type)) {
        // this.files.push(file);
        // this.uploadedDocs.push(file);
        const docObj = {
          name: file.name,
          type: file.type,
          size: file.size,   // ✅ STORE SIZE IN BYTES
          file: file,        // ✅ KEEP ORIGINAL FILE
          description: '',
          date_of_filling: null,
          tags: [],
          downloadDisabled: false,
          custom_encrypt: false
        };

        this.files.push(file);          // keep if your upload uses this
        this.uploadedDocs.push(docObj); // use object, not raw file
        this.selectedDocuments.push(docObj);

      } else {
        this.toast.error(`Invalid file format: ${file.name}`);
      }
    }
  }

  handleFileInput(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files) {
      this.handleFiles(input.files);
      input.value = ''; // 🔥 IMPORTANT: allows re-selecting same file again
    }
  }

  onDragEnter(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    // REQUIRED FOR FIREFOX
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;

    if (files && files.length > 0) {
      this.handleFiles(files);
      event.dataTransfer?.clearData();
    }
  }

  public fileOver(event: any) {
    //console.log(event);
  }

  public fileLeave(event: any) {
    //console.log(event);
  }
  removeNewDocument(item: any, i: number) {
    // Close editor if this document is being edited
    if (this.selectedIdx == i) {
        this.editDoc = false;
        this.selectedIdx = null;
        this.currentDocTags = [];
        this.showTagInputs = false;
    }
    
    if (this.uploadedDocs.length == 1) {
        this.editMetaData = false;
        this.editDoc = false;
    }
    
    // Remove from arrays
    this.uploadedDocs.splice(i, 1);
    this.files.splice(i, 1);
    
    // If we removed a document before the selected one, adjust selectedIdx
    if (this.selectedIdx !== null && this.selectedIdx >= this.uploadedDocs.length) {
        this.selectedIdx = null;
        this.editDoc = false;
    }
    
    this.toast.error('Document removed');
}
//   docEnable(item: any) {
//     this.downloadDisabled = item == "enable" ? true : false;
//   }
  filterDoc(data: any) { 
    this.addTag = !this.addTag;
    this.noOfDocs = this.uploadedDocs.filter((value: any) => value.checked).length; 
    //console.log("===>",this.noOfDocs)
    
    if (data == 'editMeta') {
      this.editMetaData = true;
    }
    this.editMetaFlag = data == "editMeta" ? true : false;
  }

  // master
  checkAllItem(event: Event) {
    const input = event.target as HTMLInputElement;
    const checked = input.checked;

    this.allCheck = checked;
    this.isIndeterminate = false; // master clicked resets indeterminate
    this.uploadedDocs.forEach((doc: any) => doc.checked = checked);
    this.noOfDocs = this.uploadedDocs.filter((v: any) => v.checked).length;
  }

  // individual
  checkedItem(event: Event, obj: any) {
    const input = event.target as HTMLInputElement;
    const checked = input.checked;

    obj.checked = checked;
    this.noOfDocs = this.uploadedDocs.filter((v: any) => v.checked).length;

    const total = this.uploadedDocs.length;
    const selected = this.noOfDocs;

    this.allCheck = selected === total;                 // full select
    this.isIndeterminate = selected > 0 && selected < total; // partial
  }

  // checkAllItem(event: any) {
  //   this.allCheck = event; // master state
  //   if (event) {
  //     for (let i = 0; i < this.uploadedDocs.length; i++) {
  //       this.uploadedDocs[i].checked = true;
  //     }
  //   } else {
  //     for (let i = 0; i < this.uploadedDocs.length; i++) {
  //       this.uploadedDocs[i].checked = false;
  //     }
  //   }
  //     this.noOfDocs = this.uploadedDocs.filter((value: any) => value.checked).length;
  // }


  // editDocument(item: any, i: any) {
  //   item.description = ' ';
  //   this.selectedIdx = i;
  //   this.editDoc = true;
  //   //  this.editMeta = item;
  //   if(item.description)
  //   this.documentDetail.controls["description"].setValue(item.description);
  //   this.documentDetail.controls["date_of_filling"].setValue(item.date_of_filling);
  //   this.documentDetail.controls["name"].setValue(item.name);
  //   //console.log(" this.editMeta  " + JSON.stringify(this.editMeta))
  // }

// checkAllItem(event: Event) {
//   const checked = (event.target as HTMLInputElement).checked;
//   this.allCheck = checked;
//   this.uploadedDocs.forEach((doc: any) => doc.checked = checked);
//   this.noOfDocs = this.uploadedDocs.filter((value: any) => value.checked).length;
// }


//   checkedItem(val: Event, obj: any) {
//     obj.checked = val;// Update the clicked item

//     this.uploadedDocs.forEach((item: any) => {

//       if (item.name == obj.name) {
//         if (val) {
//           item.checked = true;
//         } else {
//           item.checked = false;
//           // this.isDisplayTags = false;
//         }
//       }
//     });
//     this.noOfDocs = this.uploadedDocs.filter((value: any) => value.checked).length; // Update count
//     // this.uploadedDocs.forEach((item: any) => {
//     //   if (item.name == val.name) {
//     //     item.checked = true;
//     //   }
//     // })

//     // If all are checked, master must be checked; otherwise false
//     this.allCheck = this.uploadedDocs.every((value: any) => value.checked);
//   }



  // onSubmit() {
  //   //console.log('this.documentDetail',this.documentDetail)
  //   if(this.documentDetail.value.name == ""){
  //     this.toast.error('Please enter the document name');
  //     return;
  //   }
  //   if (this.documentDetail.invalid) {
  //     return;
  //   }
  //   this.uploadedDocs[this.selectedIdx]=this.documentDetail.value;
  //   this.selectedIdx = null;
  //   this.submitted = true;
  //   this.editDoc = false;
  //   this.uploadedDocs.forEach((val: any) => {
  //     //console.log("val     " + JSON.stringify(val));
  //   })
  // }

  editDocument(item: any, i: any) {
    // Prevent editing multiple documents at once
    if (this.editDoc && this.selectedIdx !== null && this.selectedIdx !== i) {
        this.toast.warning('Please save or cancel your current edits before editing another document.');
        return;
    }
    
    // Toggle editing off if clicking the same document
    if (this.selectedIdx === i && this.editDoc) {
        this.cancelEdit();
        return;
    }
    
    this.selectedIdx = i;
    this.editDoc = true;
    
    // Load tags if they exist
    if (item.tags && Array.isArray(item.tags) && item.tags.length > 0) {
        this.currentDocTags = JSON.parse(JSON.stringify(item.tags));
        this.showTagInputs = true;
    } else {
        this.currentDocTags = [];
        this.showTagInputs = false;
    }
    
    // Set form values - auto-fill description if empty
    const descriptionValue = item.description && item.description.trim() !== '' 
        ? item.description 
        : item.name;
    
    this.documentDetail.patchValue({
        name: item.name,
        description: descriptionValue,
        date_of_filling: item.date_of_filling || null
    });
}

addTagRow() {
    if (!this.showTagInputs) {
        this.showTagInputs = true;
    }
    this.currentDocTags.push({ tagtype: "", tag: "" });
}

removeTagRow(index: number) {
    this.currentDocTags.splice(index, 1);
    if (this.currentDocTags.length === 0) {
        this.showTagInputs = false;
    }
}
  
  onSubmit() {
    this.submitted = true;
    
    // Validate tags if they're shown
    if (this.showTagInputs) {
        for (const item of this.currentDocTags) {
            if (!item.tagtype || !item.tagtype.trim() ||
                !item.tag || !item.tag.trim()) {
                this.toast.error('Please fill all tag fields or remove empty tags');
                return;
            }
            
            if (item.tagtype.length > 30) {
                this.toast.error('Tag Type cannot exceed 30 characters');
                return;
            }
            
            if (item.tag.length > 100) {
                this.toast.error('Tag cannot exceed 100 characters');
                return;
            }
        }
    }
    
    // Auto-fill description if empty
    const formValue = this.documentDetail.value;
    if (!formValue.description || formValue.description.trim() === '') {
        this.documentDetail.patchValue({
            description: formValue.name
        });
    }
    
    if (this.documentDetail.invalid) {
        if (this.documentDetail.get('date_of_filling')?.errors?.notFutureDate) {
            this.toast.error('Expiration date must be in the future');
        }
        return;
    }
    
    // Update the selected document with new values
    const updatedDoc = {
        ...this.uploadedDocs[this.selectedIdx],
        name: this.documentDetail.value.name,
        size: this.uploadedDocs[this.selectedIdx].size,
        description: this.documentDetail.value.description || this.documentDetail.value.name,
        date_of_filling: this.documentDetail.value.date_of_filling,
        tags: this.currentDocTags.filter(tag => 
            tag.tagtype && tag.tagtype.trim() && tag.tag && tag.tag.trim()
        ).map(tag => ({
            tagtype: tag.tagtype.trim(),
            tag: tag.tag.trim()
        }))
    };
    
    this.uploadedDocs[this.selectedIdx] = updatedDoc;
    
    // Reset form state
    this.selectedIdx = null;
    this.submitted = true;
    this.editDoc = false;
    this.currentDocTags = [];
    this.showTagInputs = false;
    
    this.toast.success('Document metadata updated successfully');
}

  onResetTags() {  
    this.addTag = false
    this.noOfDocs = 0
    this.editMetaFlag = true;
    this.values = [];  
    this.metaData = {};
    this.addvalue()
  }
  cancelEdit() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Alert', message: `Changes you made will not be saved. Do you want to continue?` }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.onReset();
      }
    });
  }
  onReset() {
    this.submitted = false;
    this.documentDetail.patchValue({
        name: '',
        date_of_filling: null,
        description: ''
    });
    this.editDoc = false;
    this.selectedIdx = null;
    this.currentDocTags = [];
    this.showTagInputs = false;
}

  saveUploadedDocuments() {     
    // console.log('uploadedDocs',this.uploadedDocs)
    // this.confirmationDialogService.confirm('Confirmation', 'Are you sure you want to upload documents to ' + this.data?.title + '?', true, 'Yes', 'No')
//     this.confirmationDialogService.confirm('Confirmation', 'Are you sure you want to upload documents to this matter?', true, 'Yes', 'No')
//       .then((confirmed) => {
//         if (confirmed) {
//           //debugger
//           const uploadPromises = []; 
//           for (var i = 0; i < this.uploadedDocs.length; i++) {
//             let fdata = new FormData();
               
//             // let file: File = this.uploadedDocs[i];
//             // let fileName = file.name.split('.')[0]; // Extract filename without extension
//             // let truncatedName = fileName.length > 50 ? fileName.substring(0, 50) : fileName; // Limit to 50 characters
//             // console.log('truncname', truncatedName)

//             this.description = this.uploadedDocs[i].description?.trim() || this.uploadedDocs[i].name;
//             // const ids = this.data.groups.map((obj: any) => obj.id);
//             // const groupAcls = this.data.groupAcls;
//             fdata.append('name', this.uploadedDocs[i].name);
//             fdata.append('description', this.description);
//             //fdata.append('description', this.uploadedDocs[i].description);
//             fdata.append('filename', this.uploadedDocs[i].name)
//             fdata.append('content_type', this.uploadedDocs[i].type)
//             fdata.append('category', "client")
//             //fdata.append('group_acls', JSON.stringify(this.data.groupAcls))
//             // if (ids.length > 0) {
//             //   fdata.append('groups', JSON.stringify(ids))
//             // }
//             //fdata.append('groups', JSON.stringify(groupAcls))
//             fdata.append('file', this.files[i])
//             //let sb = [this.data?.title];
//             let mtrs = [this.data?.id];
//             // fdata.append('subcategories', JSON.stringify(sb))
//             fdata.append('matters', JSON.stringify(mtrs))
//             // let clients = this.data.clients.concat(this.data.corporate);

//             // let clientsPayload;
//             // if (this.isMarketplace) {
//             //   let c = localStorage.getItem('marketplace_id');
//             //   clientsPayload = [
//             //     {
//             //       id: c,
//             //       type: 'legal'
//             //     }
//             //   ];
//             // } else {
//             //   clientsPayload = clients.map((obj: any) => ({
//             //     id: obj.id,
//             //     type: obj.type
//             //   }));
//             // }
//             // fdata.append('clients', JSON.stringify(clientsPayload));

//             let clients = [
//               ...(this.data?.clients || []),
//               ...(this.data?.corporate || [])
//             ];
//             let clientsPayload;
//             if (this.isMarketplace) {
//               let c = localStorage.getItem('marketplace_id');
//               clientsPayload = [
//                 {
//                   id: c,
//                   type: 'legal'
//                 }
//               ];
//             } else {
//               clientsPayload = clients.map((obj: any) => ({
//                 id: obj.id,
//                 type: obj.type
//               }));
//             }
//             fdata.append('clients', JSON.stringify(clientsPayload));


//             //fdata.append('clients', JSON.stringify(clients.map((obj: any) => ({ "id": obj.id, "type": obj.type }))))

//             const formatDate = (dateString: string | Date): string => {
//               const date = new Date(dateString);
//               const day = String(date.getDate()).padStart(2, '0');
//               const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
//               const year = date.getFullYear();
//               return `${day}-${month}-${year}`;
//             };

//             // Format expiration_date if it exists
//             const formattedExpirationDate = this.uploadedDocs[i].date_of_filling ? formatDate(this.uploadedDocs[i].date_of_filling) : '';
//             fdata.append('expiration_date', formattedExpirationDate);
//             //fdata.append('downloadDisabled', this.downloadDisabled.toString()); 
//             //fdata.append('encryptDisabled', this.encryptDisabled.toString());
//             // fdata.append('downloadDisabled', this.uploadedDocs[i].downloadDisabled);
//             // fdata.append('custom_encrypt', this.uploadedDocs[i].custom_encrypt);

//             fdata.append('downloadDisabled', (!!this.uploadedDocs[i].downloadDisabled).toString());
//             fdata.append('custom_encrypt', (!!this.uploadedDocs[i].custom_encrypt).toString());
//             let tagsObj: any = {};

// if (this.uploadedDocs[i].tags?.length > 0) {
//     this.uploadedDocs[i].tags.forEach((tag: any) => {
//         if (tag.tagtype?.trim() && tag.tag?.trim()) {
//             tagsObj[tag.tagtype.trim()] = tag.tag.trim();
//         }
//     });
// }

// if (Object.keys(tagsObj).length > 0) {
//     fdata.append('tags', JSON.stringify(tagsObj));
// }
//             uploadPromises.push(this.upload(i, fdata,this.uploadedDocs[i]));
//           }
//           Promise.all(uploadPromises)
//             .then((results) => { 
//                 console.log('resul',results)

//               // Process the results if needed
//               //this.getDocuments();
//               // this.AddExistingSelected = true;
//               // this.UploadDocSelected = false;
//               //this.showAlert('Files uploaded successfully!', false);
//               //this.toast.success('Files uploaded successfully!')
//             },

//             )
//             .catch(
//             //   (error) => {
//             //   this.showAlert(' ' + error, true);
//             // }
//             );
//         }
//       },
//       );

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Confirmation', message: `Are you sure you want to upload documents to this matter?` }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      //console.log('Dialog result:', result);
      if (result) {
        const uploadPromises = [];
        for (var i = 0; i < this.uploadedDocs.length; i++) {
          let fdata = new FormData();

          // let file: File = this.uploadedDocs[i];
          // let fileName = file.name.split('.')[0]; // Extract filename without extension
          // let truncatedName = fileName.length > 50 ? fileName.substring(0, 50) : fileName; // Limit to 50 characters
          // console.log('truncname', truncatedName)

          this.description = this.uploadedDocs[i].description?.trim() || this.uploadedDocs[i].name;
          // const ids = this.data.groups.map((obj: any) => obj.id);
          // const groupAcls = this.data.groupAcls;
          fdata.append('name', this.uploadedDocs[i].name);
          fdata.append('description', this.description);
          //fdata.append('description', this.uploadedDocs[i].description);
          fdata.append('filename', this.uploadedDocs[i].name)
          fdata.append('content_type', this.uploadedDocs[i].type)
          fdata.append('category', "client")
          //fdata.append('group_acls', JSON.stringify(this.data.groupAcls))
          // if (ids.length > 0) {
          //   fdata.append('groups', JSON.stringify(ids))
          // }
          //fdata.append('groups', JSON.stringify(groupAcls))
          fdata.append('file', this.files[i])
          //let sb = [this.data?.title];
          let mtrs = [this.data?.id];
          // fdata.append('subcategories', JSON.stringify(sb))
          fdata.append('matters', JSON.stringify(mtrs))
          // let clients = this.data.clients.concat(this.data.corporate);

          // let clientsPayload;
          // if (this.isMarketplace) {
          //   let c = localStorage.getItem('marketplace_id');
          //   clientsPayload = [
          //     {
          //       id: c,
          //       type: 'legal'
          //     }
          //   ];
          // } else {
          //   clientsPayload = clients.map((obj: any) => ({
          //     id: obj.id,
          //     type: obj.type
          //   }));
          // }
          // fdata.append('clients', JSON.stringify(clientsPayload));

          let clients = [
            ...(this.data?.clients || []),
            ...(this.data?.corporate || [])
          ];
          let clientsPayload;
          if (this.isMarketplace) {
            let c = localStorage.getItem('marketplace_id');
            clientsPayload = [
              {
                id: c,
                type: 'legal'
              }
            ];
          } else {
            clientsPayload = clients.map((obj: any) => ({
              id: obj.id,
              type: obj.type
            }));
          }
          fdata.append('clients', JSON.stringify(clientsPayload));


          //fdata.append('clients', JSON.stringify(clients.map((obj: any) => ({ "id": obj.id, "type": obj.type }))))

          const formatDate = (dateString: string | Date): string => {
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
          };

          // Format expiration_date if it exists
          const formattedExpirationDate = this.uploadedDocs[i].date_of_filling ? formatDate(this.uploadedDocs[i].date_of_filling) : '';
          fdata.append('expiration_date', formattedExpirationDate);
          //fdata.append('downloadDisabled', this.downloadDisabled.toString()); 
          //fdata.append('encryptDisabled', this.encryptDisabled.toString());
          // fdata.append('downloadDisabled', this.uploadedDocs[i].downloadDisabled);
          // fdata.append('custom_encrypt', this.uploadedDocs[i].custom_encrypt);

          fdata.append('downloadDisabled', (!!this.uploadedDocs[i].downloadDisabled).toString());
          fdata.append('custom_encrypt', (!!this.uploadedDocs[i].custom_encrypt).toString());
          let tagsObj: any = {};

          if (this.uploadedDocs[i].tags?.length > 0) {
            this.uploadedDocs[i].tags.forEach((tag: any) => {
              if (tag.tagtype?.trim() && tag.tag?.trim()) {
                tagsObj[tag.tagtype.trim()] = tag.tag.trim();
              }
            });
          }

          if (Object.keys(tagsObj).length > 0) {
            fdata.append('tags', JSON.stringify(tagsObj));
          }
          uploadPromises.push(this.upload(i, fdata, this.uploadedDocs[i]));
        }
        Promise.all(uploadPromises)
          .then((results) => {
            //console.log('resul', results)

            // Process the results if needed
            //this.getDocuments();
            // this.AddExistingSelected = true;
            // this.UploadDocSelected = false;
            //this.showAlert('Files uploaded successfully!', false);
            //this.toast.success('Files uploaded successfully!')
          },

          )
          .catch(
          //   (error) => {
          //   this.showAlert(' ' + error, true);
          // }
        );
      }
    });

  }
  
  upload(idx: any, file: any,data:any) {
    //return new Promise((resolve, reject) => {
     this.spinnerService.show();
      this.httpservice.sendPostRequest(URLUtils.postDocumentsClient, file).subscribe(
        (res: any) => {
           this.spinnerService.hide();
          if (!res.error) {
            let obj = [{
              "docid": res.docid,
              "doctype": 'general',
              "user_id": localStorage.getItem('user_id')
            }];
  
            var currentDateTime = new Date().toLocaleString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            });

            let doc = {
              "docid": res.docid,
              "doctype": 'general',
              "user_id": localStorage.getItem('user_id'),
              "name":data.name,
              "description":this.description,
              "added_encryption":false,
              "created": currentDateTime,
              "addedBy":localStorage.getItem('name')
            }
            //console.log('doc',doc)
                      
            this.AddExistingSelected = true; //return to exist
            this.UploadDocSelected = false; //return to exist
            this.onFeatureClick('Document'); //get updated data
            this.selectedDocuments.push(doc)
            this.createdBy = localStorage.getItem('name'); //Get value from localStorage
            // this.httpservice.sendPutRequest(URLUtils.legalHistoryDocumentsUpdate(this.data.id), { "documents": obj }).subscribe(
            //   (res: any) => {
            //     //console.log(res);
            //   });
            //resolve(res.msg);
            this.toast.success(res.msg) 
            this.AddExistingSelected = true;
            this.UploadDocSelected = false; 
            this.values = []; 
            this.addvalue();
            //this.getDocuments();
            // this.showUpload=true; //show upload btn
          } 
          else {
            this.toast.error(res.msg)
            //reject(res.msg);
          }
          
        },
        // (err: any) => {
        //   reject(err.msg);
        // }
        (error: HttpErrorResponse) => {
          if (error.status === 400 || error.status === 401 || error.status === 403) {
            const errorMessage = error.error.msg || 'Unauthorized';
            this.toast.error(errorMessage);
            //console.log(error);
          }
        }
      );
      //this.getDocuments();
    //});
  }

  showAlert(message: string, isError: boolean) {
    const alertType = isError ? 'Alert' : 'Alert';
    this.confirmationDialogService.confirm(alertType, message, false, '', '', false, 'sm', false);
  }

  onUploadCancel() {
    //console.log('uploadedDocs',this.uploadedDocs)

    this.DragAndDropView = true;
    this.uploadedDocs = [];
    this.files=[];
    
    this.onFeatureAddNewDoc('Document');
    this.isNewDocument= !this.isNewDocument;
    this.AddExistingSelected = false;
    this.UploadDocSelected=false; 
    this.showUpload=true;             
  }
  onMergeCancel() {
    // this.onFeatureClick('Document');
    this.selectedDocuments.forEach((val: any) => { val.checked = false });
    this.selectedMergeDocuments = [];
    let checkbox = document.getElementById('mergeSelectAll') as HTMLInputElement | null;
    if (checkbox != null)
      checkbox.checked = false;
  }
  keyup(cat: any) {
    //console.log("ghgj" + this.searchText);
    if (cat == 'doc') {
      if (this.searchText == ' ')
        this.searchText = this.searchText.replace(/\s/g, "");
      this.filteredDataDocs = this.documentsList.filter((item: any) => item.name.toLocaleLowerCase().includes(this.searchText));
      let checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
      if (checkbox != null)
        checkbox.checked = false;
    }
    else if (cat == 'clnt') {
      if (this.searchTextClient == ' ')
        this.searchTextClient = this.searchTextClient.replace(/\s/g, "");
      this.filteredDataClnts = this.clientsList.filter((item: any) => item.name.toLocaleLowerCase().includes(this.searchText));
      // let checkbox = document.getElementById('selectAllClients') as HTMLInputElement | null;
      // if (checkbox != null)
      //   checkbox.checked = false;
      this.checkSelectAllClient(); //update selectAll
    }
    else if (cat == 'tm') {
      if (this.searchTextMembers == ' ')
        this.searchTextMembers = this.searchTextMembers.replace(/\s/g, "");
      this.filteredDataTms = this.teammembersList.filter((item: any) => item.name.toLocaleLowerCase().includes(this.searchText));
      //let checkbox = document.getElementById('selectAllMembers') as HTMLInputElement | null;
      // if (checkbox != null)
      //   checkbox.checked = false;
      this.checkSelectAllTM(); //update selectAll
    }
    
  }
  // onMessageClick(member:any) {
  //   sessionStorage.setItem('selectedMember',JSON.stringify(member));
  //   const link =  `/messages/clients`;
  //   window.location.href = link;
  //   //this.router.navigate(['/messages/clients'])
  // }
  onMessageClick(member: any) {
    console.log('MATTER CLIENT CLICKED:', member); 
    this.router.navigate(['/messages/clients'], {
      state: {
        clientId: member.id,   // must be the same guid value used as Contact.guid in MessagesComponent
        source: 'matter'
      }
    });
  }
  onMessageClickTM(member:any) {
    sessionStorage.setItem('selectedMember',JSON.stringify(member));
    // const link =  `/messages/teams`;
    // window.location.href = link;
    this.router.navigate(['/messages/teams']);
  }
  onMailClick() {
    const link =  `/emails`;
    window.location.href = link;
    //this.router.navigate(['/emails'])
  }
  restricttextSpace(event: any) {
    let inputValue: string = event.target.value;
    inputValue = inputValue.replace(/^\s+/, '');
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    event.target.value = inputValue;
  }
  setNewDepartureDate() {
    let startDate = new Date(this.documentDetail.controls.dateArrival.value);
    //console.log(startDate);
} 

docEnable(action: string) {
    this.downloadDisabled = action == "enable" ? false : true;
    this.uploadedDocs.forEach((item: any) => {
        item.downloadDisabled = this.downloadDisabled;
    });
}    
encryptEnable(action: string) {
this.encryptDisabled = action === "enable" ? true : false;
this.uploadedDocs.forEach((item: any) => {
    item.custom_encrypt = this.encryptDisabled;
});
}
disableDoc(val: any, currentState: boolean) {
    val.downloadDisabled = !currentState;
    
    // Update in uploadedDocs array
    const index = this.uploadedDocs.findIndex((doc: any) => doc === val);
    if (index !== -1) {
        this.uploadedDocs[index].downloadDisabled = val.downloadDisabled;
    }
} 

encrypttoggle(val: any, currentState: boolean) {
    val.custom_encrypt = !currentState;
    
    // Update in uploadedDocs array
    const index = this.uploadedDocs.findIndex((doc: any) => doc === val);
    if (index !== -1) {
        this.uploadedDocs[index].custom_encrypt = val.custom_encrypt;
    }
}


restrictSpaces(event: any) {
    let inputValue: string = event.target.value;
    // Replace multiple spaces with a single space
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    event.target.value = inputValue;
  }

  // getTagList(tagsObj: { [key: string]: string }): string[] {
  //   return Object.values(tagsObj);
  // }
  getTagList(tagsObj: { [key: string]: string } | null | undefined): string[] {
  return tagsObj ? Object.values(tagsObj) : [];
}

onClientClick(client:any){

  type ClientType = 'consumer' | 'entity' | 'corporate';

  const clientTypes: Record<ClientType, string> = {
    consumer: 'individuals',
    entity: 'business',
    corporate: 'corporate'
  };
  const filter = clientTypes[client.type as ClientType] ?? 'individuals';
  this.router.navigate(
    ['/relationship/view/',filter],
    {
      queryParams: {
        relationshipId: client.relid,
        // clientId: client.id,
        clientType: client.type,
        tab: 'profile',
        pending: client.pending
      }
    }
  );
}

// truncate(value: string, limit: number): string {
//   if (!value) return '';
//   return value.length > limit ? value.substr(0, limit) + '…' : value;
// }

// Grouplist client functions
// uploadMore() {
//   this.uploadDocs = [];
// }
// selectGroupItem(item: any, val: any) {
//   //console.log("--selected item" + JSON.stringify(item) + val);
//   if (val) {
//       item.isChecked = val;
//       this.selectedGroupItems.push(item);
//       //this.selectedGroupItems = this.selectedGroupItems.filter((el:any, i:any, a:any) => i === a.indexOf(el));

//   } else {
//       item.isChecked = val;
//       let index = this.selectedGroupItems.findIndex((d: any) => d.id === item.id);
//       //console.log(item.id);
//       this.selectedGroupItems.splice(index, 1);
//   }
//   localStorage.setItem("groupIds", JSON.stringify(this.selectedGroupItems));
//   //console.log("selected " + JSON.stringify(this.selectedGroupItems));
// }
// removeGroup(item: any) {
//   item.isChecked = false;
//   let index = this.selectedGroupItems.findIndex((d: any) => d.id === item.id); //find index in your array
//   this.selectedGroupItems.splice(index, 1);
//   this.get_all_matters(this.selectedmatterType)
// }
// selectEvent(item: any) {
//   localStorage.setItem("clientData", JSON.stringify(item));
//       this.clientId.push(item);
//       this.httpservice.sendGetRequest(URLUtils.getMattersByClient(item)).subscribe((res: any) => {
//           this.matterList = res?.matterList;
//       });

//       let clientInfo = new Array();
//       this.clientId?.forEach((item: any) => {
//           let clientData = {
//               "id": item.id,
//               "type": item.type
//           };
//           clientInfo.push(clientData);
//       });

//       this.httpservice.sendPutRequest(URLUtils.getGrouplist, { "clients": clientInfo }).subscribe((res: any) => {
//           if (res.error == false) {
//               this.grouplist = res?.data;
//               //Filter and check groups based on the API res.
//               this.selectedGroupItems = this.groupViewItems.filter((groupItem: any) => {
//                   groupItem.isChecked = this.grouplist.some((selectedGroup: any) => selectedGroup.id === groupItem.id);
//                   return groupItem.isChecked;
//               });

//               //Update the checkboxes in groupViewItems
//               // this.groupViewItems.forEach((groupItem: any) => {
//               //     groupItem.isChecked = this.selectedGroupItems.some((selectedGroup: any) => selectedGroup.id === groupItem.id);
//               // });
//           }
//       });
// }
// selectGroup(val: boolean) {
//   this.isSelectGroup = val;
//   if(!val){
//       this.get_all_matters(this.selectedmatterType)
//   }
// }
// onChangeSearch(val: any) {
//   if (val == undefined) {
//       this.clientId = [];
//   }
// }
// onFocused(e: any) {
//   //console.log("onFocused " + JSON.stringify(e));
//   // do something when input is focused
// }
// getClients() {
//   this.relationshipSubscribe = this.httpservice.getFeaturesdata(URLUtils.getAllRelationship).subscribe((res: any) => {
//       this.reldata = res?.data?.relationships;
//       this.httpservice.getFeaturesdata(URLUtils.getCalenderExternal).subscribe((res: any) => {
//           this.corpData = res?.relationships.map((obj:any)=>({ "id": obj.id, "type": "corporate" ,"name":obj.name}))
//           this.clientdata = this.reldata.concat(this.corpData)
//       });
      
//   });

//   this.httpservice.sendGetRequest(URLUtils.getGroups).subscribe((res: any) => {
//     this.groupViewItems = res?.data;
//     this.groupViewItems.forEach((item: any) => {
//         item.isChecked = false;
//     })
// })
// }
// get_all_matters(type:any,event?:any){
//   this.spinnerService.show()
//   let selectedGroups: any = [];
//   this.selectedGroupItems?.forEach((item: any) => {
//       selectedGroups.push(item.id)
//   })
//   let payload = {"grp_acls":selectedGroups}
//   if(type=='internal'){
//       this.httpservice.sendPutRequest(URLUtils.getAllMatters,payload).subscribe((res:any)=>{
//           if(res.error == false){
//               this.corp_matter_list = res.matterList
//               this.spinnerService.hide()
//           } else {
//               this.spinnerService.hide()
//           }
//       },(err:any)=>{
//           console.log(err)
//           this.spinnerService.hide()
//       })
//   }
//   if(type == 'external'){
//       this.httpservice.sendPutRequest(URLUtils.getAllExternalMatters,payload).subscribe((res:any)=>{
//           if(res){
//               this.corp_matter_list = res.matterList
//               this.spinnerService.hide()
//           }
//       },(err:any)=>{
//           this.spinnerService.hide()
//       })

//   }
// }

  selectedClient(clients: any) {
    //console.log('from V clients', clients)
    this.selectedTabItem = 'matter-clients';
  }

  onClickCorp() {
    //this.isSaveEnable = true;
    let flag = false;
    for (let i = 0; i < this.selectedClients.length; i++) {
      //console.log("Corp selected clients",this.selectedClients)
      if (this.selectedClients[i].type === "corporate") {
        this.selectedClients[i] = this.selectedOption;
        flag = true;
        break;
      }
    }
    if (!flag) {
      this.selectedClients.push(this.selectedOption);
    }
  }

  sendReq(req?: any) {
    // console.log('ss',req)
    // console.log('ss reqid', this.reqId)
    // console.log('ss selectedClients', this.selectedClients);

    let ebody = {
      "entityId": req.id,
      "description": "Description",
    }
    let cbody = {
      "consumerId": req.id,
      "description": "Description",
    }

    if (req.type === "consumer") {
      this.httpservice.sendPostRequest(URLUtils.relationshipConsumerRequest, cbody).subscribe(
        (resp: any) => {
          // if (resp.error === false)
          //   //this.toast.success("Client Request Sent Successfully");
          //    console.log(resp)
          // else
          //   this.toast.error(resp.msg);
        },
        (error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            const errorMessage = error.error.msg || 'Unauthorized';
            this.toast.error(errorMessage);
            //console.log(error);
          }
        })
    }
    else if (req.type === "entity") {
      this.httpservice.sendPostRequest(URLUtils.relationshipEntityRequest, ebody).subscribe(
        (resp: any) => {
          // if (resp.error === false)
          //     //this.toast.success("Client Request Sent Successfully");
          //    console.log(resp)
          // else
          //   this.toast.error(resp.msg);
        },
        (error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            const errorMessage = error.error.msg || 'Unauthorized';
            this.toast.error(errorMessage);
            //console.log(error);
          }
        });
    }
    else if (req.type === "corporate") {
      this.httpservice.sendPostRequest(URLUtils.relationshipCorporateRequest, ebody).subscribe(
        (resp: any) => {
          // if (resp.error === false)
          //   //this.toast.success("Client Request Sent Successfully");
          //    console.log(resp)
          // else
          //   this.toast.error(resp.msg);
        },
        (error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            const errorMessage = error.error.msg || 'Unauthorized';
            this.toast.error(errorMessage);
            //console.log(error);
          }
        });
    }
    else { }
  }

  // onOptSel(event: any) {
  //   this.isSaveEnableClient = false;
  //   const selectedName = event.option.value;
  //   const selectedObj = this.currentSearchList.find((c: any) => c.client_name === selectedName);

  //   if (selectedObj && !this.selectedClients.some((c: any) => c.id === selectedObj.client_id)) {

  //     const addedClient = {
  //       id: selectedObj.client_id,
  //       name: selectedObj.client_name,
  //       type: selectedObj.type,
  //       send_request: selectedObj.send_request
  //     };
  //     //console.log('add',addedClient)
  //     this.selectedClients.push(addedClient);

  //     this.reqId = addedClient.id; //add reqapi

  //     // FIXED: send_request should be checked from addedClient
  //     if (addedClient.send_request === true) {
  //       this.sendReq(addedClient);
  //     }
  //   }
  //   this.httpservice.setClients(this.selectedClients); //observing the selectedClients
  //   this.selectedEntity.setValue(null); // clears input
  // }

  onOptSel(event: any) {
    this.isSaveEnableClient = false;
    const selectedName = event.option.value;
    const selectedObj = this.currentSearchList.find(
      (c: any) => c.client_name === selectedName
    );

    if (!selectedObj) return;

    const isCorporate = selectedObj.type === 'corporate';
    const hasCorporate = this.hasCorporateSelected;
    const hasNonCorporate = this.hasNonCorporateSelected;
    //console.log('this.showTempForm',this.showTempForm)

    // Corporate already selected → block another corporate
    if (isCorporate && hasCorporate) {
        // this.confirmationDialogService.confirm(
        //     'Alert',
        //     'Multi Corporate Client Selection Not Allowed',
        //     false,
        //     'OK',
        //     'Cancel',
        //     true
        // );
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: { title: 'Alert', message: `Multi Corporate Client Selection Not Allowed`,hideButtons: true }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
            }
        });
        this.selectedEntity.setValue(null);
        return;
    }

    // Corporate selected → block entity / consumer
    if (!isCorporate && hasCorporate || (this.showTempForm === false && hasCorporate)) {
        // this.confirmationDialogService.confirm(
        //     'Alert',
        //     'This action is not allowed: Corporate clients cannot be grouped with other clients.',
        //     false,
        //     'OK',
        //     'Cancel',
        //     true
        // );
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: {
                title: 'Alert', message: `This action is not allowed: Corporate clients cannot be grouped with other clients.`, hideButtons: true
            }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
            }
        });
        this.selectedEntity.setValue(null);
        return;
    }

    // Entity / Consumer selected → block corporate
    if (isCorporate && hasNonCorporate) {
        // this.confirmationDialogService.confirm(
        //     'Alert',
        //     'Corporate client can not be added when other clients are already selected',
        //     false,
        //     'OK',
        //     'Cancel',
        //     true
        // );
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: { title: 'Alert', message: `Corporate client can not be added when other clients are already selected.`,hideButtons: true }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result) {
            }
        });
        this.selectedEntity.setValue(null);
        return;
    }

    // Duplicate check
    if (this.selectedClients.some((c: any) => c.id === selectedObj.client_id)) {
      this.selectedEntity.setValue(null);
      return;
    }

    // Add client
    const addedClient = {
      id: selectedObj.client_id,
      name: selectedObj.client_name,
      type: selectedObj.type,
      send_request: selectedObj.send_request
    };

    this.selectedClients.push(addedClient);
    this.toast.success("Client Request Sent Successfully");
    this.reqId = addedClient.id;

    if (addedClient.send_request) {
      this.sendReq(addedClient);
    }

    this.httpservice.setClients(this.selectedClients);
    this.selectedEntity.setValue(null);
  }

  get hasCorporateSelected(): boolean {
    return this.selectedClients.some((c: any) => c.type === 'corporate');
  }

  get hasNonCorporateSelected(): boolean {
    return this.selectedClients.some(
      (c: any) => c.type !== 'corporate'
    );
  }

  stopOpen() {
    if (!this.selectedEntity.value || this.selectedEntity.value.trim() === '') {
      //this.auto.closePanel();
      this.selectedEntity.setValue('');
    }
  }

  // removeClient(client: any) {
  //     this.selectedClients = this.selectedClients.filter((c: any) => c.id !== client.id);
  //     this.selectedEntity.setValue(null); // clears input
  // }

  searchEntity() { }

  getType(e: any, type: any) {
    // console.log('type',type)
    // console.log('e.target.name',e.target.name)
    // console.log('tempClient',this.tempClient.value)
    // console.log('entityClient',this.entityClient.value)

    // || this.tempClient.dirty ||  this.tempClient.touched || this.entityClient.dirty ||  this.entityClient.touched 

    // const tempVal = (this.tempClient.value.name.length > 1 || this.tempClient.value.lastName.length > 1 || this.tempClient.value.email.length > 1 || this.tempClient.value.country.length > 1);
    // const entityVal = (this.entityClient.value.fullname.length > 1 || this.entityClient.value.contact_person.length > 1 || this.entityClient.value.email.length > 1 || this.entityClient.value.country.length > 1);

    const tempVal = this.tempClient.dirty;
    const entityVal = this.entityClient.dirty;

    if (tempVal) {
      this.successModel = true;
      return;
    }
    else if (entityVal) {
      this.successModel = true;
      return;
    }
    else {
      this.selectedType = type;
      this.successModel = false;
      this.ClientType = e.target.name;
      this.CorpType
      this.tempClient.controls.type.patchValue(type);
    }
  }

  oneEntitySubmit(submitType: string) {
    this.isSaveEnableClient = false;
    this.inputsubmit = submitType;
    // this.isSaveEnable = true;
    this.entitysubmitted = true;
    if (this.entityClient.invalid) {
        return;
    }
    // Check if email and confirmemail do not match
    if (this.entityClient.value.confirmemail !== this.entityClient.value.email) {
      return;
    }
    if (this.inputsubmit == 'entity') {
      let object = {
        "fullname": this.entityClient.value.fullname,
        "contact_person": this.entityClient.value.contact_person,
        "email": this.entityClient.value.email,
        "contact_phone": this.entityClient.value.phonenumber,
        "country": this.entityClient.value.country,
        //"group_acls": this.groups.map((obj: any) => obj.id)
      }

      this.httpservice.sendPostRequest(URLUtils.relationshipInviteEntity, object).subscribe((res: any) => {

        if (res.error==true) {
            this.toast.error(res.msg);
            
            this.showTempForm = false;
            this.onResetInd();
            this.onResetentity();
            this.OnFormCancel();
            this.searchTextClient = ''
            this.submitted = false; 
            return;
        }
        else {
          let dObj = {
            id: res?.profId,
            name: res?.name,
            type: 'entity'
          }
          this.selectedClients.push(dObj);
          this.toast.success('Client Invitation Sent Successfully')
          this.saveTempClientId(res.rel_id); //  temcliId to localStorage array

          this.showTempForm = false;
          this.onResetInd();
          this.onResetentity();
          this.OnFormCancel();
          this.searchTextClient = ''
          this.getClientsData();
          this.selectedEntity.setValue(null); // clears input
          // this.getTempData();
          // this.sendReq(dObj); // send req
          // this.confirmationDialogService.confirm('Success for Entity', `Congratulations! You have successfully created Entity  ${this.tempClient.value.name} to  ${this.data.Title}`, false, 'Add Team Members', 'Cancel', true)
          //     .then((confirmed) => {
          //         this.onResetentity();
          //         this.OnFormCancel();
          //     })
        }
      },
        (error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403 || error.status === 200) {
            const errorMessage = error.error.msg || 'Unauthorized';
            this.toast.error(errorMessage);
          } else if (error.status === 400) {
            if (error.error.errors) {
              error.error.errors.forEach((err: { field: string; msg: string }) => {
                if (this.entityClient.value.email.length > 1 && (err.msg === "Account already exists with this email" || err.msg === "Account already exists with this Firm Name")) {
                  this.toast.error(`${err.msg}`);
                }
              });
            } else {
              this.toast.error('Bad Request');
            }
          } else {
            this.toast.error('An unexpected error occurred');
          }
        }
      )

    }
    //this.onResetentity();
    //this.selectedEntity.setValue(null); // clears input
  }
  onindividualSubmit(submitType: string) {
    this.isSaveEnableClient = false;
    // console.log('submitType',submitType)
    // console.log('confirmemail',this.tempClient.value)
    this.inputsubmit = submitType;
    //this.isSaveEnable = true;
    this.submitted = true;
    if (this.tempClient.invalid) {
        return;
    }
    // Check if email and confirmemail do not match
    if (this.tempClient.value.confirmemail !== this.tempClient.value.email) {
      return;
    }

    if (this.inputsubmit == 'temp') {
      let obj = {
        "first_name": this.tempClient.value.name,
        "last_name": this.tempClient.value.lastName,
        "email": this.tempClient.value.email,
        "country": this.tempClient.value.country,
        "mobile": this.tempClient.value.phonenumber,
        //"group_acls": this.groups.map((obj: any) => obj.id)
      }
      // console.log('..obj',obj)
      this.httpservice.sendPostRequest(URLUtils.relationshipInviteConsumer, obj).subscribe((res: any) => {
          if (res.error==true) {
            this.toast.error(res.msg);
                        
            this.showTempForm = false;
            this.onResetInd();
            this.onResetentity();
            this.OnFormCancel();
            this.searchTextClient = ''
            this.submitted = false; 
            return;
        }
        else {
          let dObj = {
            id: res?.conId,
            name: res?.name,
            type: 'consumer'
          }
          this.selectedClients.push(dObj);

          this.toast.success('Client Invitation Sent Successfully')
          this.saveTempClientId(res.rel_id); //  temcliId to localStorage array
          
          this.showTempForm = false;
          this.onResetInd();
          this.onResetentity();
          this.OnFormCancel();
          this.searchTextClient = ''
          this.getClientsData();
          this.selectedEntity.setValue(null); // clears input
          // this.getTempData();
          // this.sendReq(dObj); // send req
          // this.confirmationDialogService.confirm('Success', 'Congratulations! You have successfully sent relationship request ', false, 'Add Team Members', 'Cancel', true)
          //     .then((confirmed) => {
          //         this.onReset();
          //         this.OnFormCancel();
          //     })
        }
        // else{
        //     this.confirmationDialogService.confirm('failed', 'sorry! You have sent duplicate  request ', false, 'Add Team Members', 'Cancel', true)
        // }
      },
        (error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403 || error.status === 200) {
            const errorMessage = error.error.msg || 'Unauthorized';
            this.toast.error(errorMessage);
          } else if (error.status === 400) {
            if (error.error.errors) {
              error.error.errors.forEach((err: { field: string; msg: string }) => {
                if (this.tempClient.value.email.length > 1 && err.msg === "Account already exists with this email") {
                  this.toast.error(`${err.msg}`);
                }
              });
            } else {
              this.toast.error('Bad Request');
            }
          } else {
            this.toast.error('An unexpected error occurred');
          }
        }
      );
    }
    //this.onReset();
    //this.selectedEntity.setValue(null); // clears input
  }

  OnFormCancel() {
    const tempVal = this.tempClient.value.name.length > 1 || this.tempClient.value.lastName.length > 1 || this.tempClient.value.email.length > 1 || this.tempClient.value.country.length > 1;
    const entityVal = this.entityClient.value.fullname.length > 1 || this.entityClient.value.contact_person.length > 1 || this.entityClient.value.email.length > 1 || this.entityClient.value.country.length > 1;

    if (tempVal) {
       this.keyModel = true;
      return;
    }
    else if (entityVal) {
       this.keyModel = true;
      return;
    }
    else {
      this.tempList = false;
      //this.isSelectAllVisible = true;
      this.showTempForm = false;
      this.entityClient.reset();
      this.tempClient.reset();
      //this.onFilterValueChange();
      this.submitted = false;
      this.entitysubmitted = false;
      //this.clientsList = this.clientsList.concat(this.selectedClients);
      this.clientsList = this.originalClientsList.filter((client: any) =>
        !this.selectedClients.includes(client)
      ); // get back the client list
      this.showTempForm = false;
      //this.selectedClients;
      //this.getClients();
      //this.getClientsData();
      //this.childButtonEvent.emit(this.clients);
      this.searchText = '';
      // this.clientsList = this.clientsList.concat(this.selectedClients);
      // this.selectedClients =[];}
    }
  }

  OnCancel() {
    // this.clientsList = this.clientsList.concat(this.selectedClients);
    // this.selectedClients = [];
    this.pathName = window.location.pathname.includes("legalmatter") ? "legalmatter" : "generalmatter";
    if (this.selectedClients.length === 0 || this.selectedClients.length > 0) {
      if (this.pathName === "legalmatter") {
        this.dialog.open(LeavepageComponent, {
          width: '350px',  // Set the width here
          height: '180px',
          hasBackdrop: true,
          panelClass: 'hello',
          disableClose: true
        });
        return;
      }
      else if (this.pathName === "generalmatter") {
        this.dialog.open(GeneralleavepageComponent, {
          width: '350px',  // Set the width here
          height: '180px',
          hasBackdrop: true,
          panelClass: 'hello',
          disableClose: true
        });
        return;
      }
      else { }
    }
    const checkbox = document.getElementById('selectAll') as HTMLInputElement | null;
    if (checkbox) {
      checkbox.checked = false;
    }
  }

  saveClients() {
    const tempVal = (this.tempClient.value.name?.length > 1 ||
      this.tempClient.value.lastName?.length > 1 ||
      this.tempClient.value.email?.length > 1 ||
      this.tempClient.value.country?.length > 1);

    const entityVal = (this.entityClient.value.fullname?.length > 1 ||
      this.entityClient.value.contact_person?.length > 1 ||
      this.entityClient.value.email?.length > 1 ||
      this.entityClient.value.country?.length > 1);

    if (tempVal || entityVal) {
      this.toast.error('Please save your changes to proceed');
      return;
    }
    else {
      let clients = this.selectedClients.filter((element: any) => element)
        .map((c: any) => ({
          id: c.id,
          type: c.type
        }));
      //console.log('payload:', clients);

      this.httpservice.sendPatchRequest(URLUtils.patchLegalMatter(this.matterId), { "clients": clients }).subscribe((res: any) => {
        // if (!res.error)
        //     this.toastr.success('Matter Info saved successfully!');
        // else if (res.error)
        //     this.toastr.error(res.msg)
      }, (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
          //console.log(error);
        }
      })

      // let selectedIds = this.tempClients.map((s: any) => s.id);
      // this.temporaryClientsEvent.emit(selectedIds)

      // let client = this.selectedClients.filter((element: any) => element);
      // this.selectedClientsEvent.emit(client);

      // // Mark that clients were saved successfully
      // this.clientsSaved.emit(true);
    }

  }

  get f0() {
    return this.tempClient.controls;
  }
  get f1() {
    return this.entityClient.controls;
  }

  // Check emails of two fields match
  emailMatchValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const formGroup = control as FormGroup;
      const email = formGroup.get('email')?.value;
      const confirmEmail = formGroup.get('confirmemail')?.value;
      return email && confirmEmail && email !== confirmEmail ? { emailMismatch: true } : null;
    };
  }

  onResetInd() {
    this.submitted = false;
    this.tempClient.controls['name'].setValue('');
    this.tempClient.controls['lastName'].setValue('');
    this.tempClient.controls['email'].setValue('');
    this.tempClient.controls['confirmemail'].setValue('');
    this.tempClient.controls['country'].setValue('');
    this.tempClient.controls['phonenumber'].setValue('');
  }
  onResetentity() {
    this.entitysubmitted = false;
    this.entityClient.controls['fullname'].setValue('');
    this.entityClient.controls['contact_person'].setValue('');
    this.entityClient.controls['email'].setValue('');
    this.entityClient.controls['confirmemail'].setValue('');
    this.entityClient.controls['country'].setValue('');
    this.entityClient.controls['phonenumber'].setValue('');
  }

  saveTempClientId(createdId: string) {
    let existing = localStorage.getItem('tempclients');
    let tempClients: string[] = existing ? JSON.parse(existing) : [];

    // Push new id if not already present
    if (!tempClients.includes(createdId)) {
      tempClients.push(createdId);
    }
    localStorage.setItem('tempclients', JSON.stringify(tempClients));

    // console.log('selectedClients',this.selectedClients)
    // console.log('Clients',this.clientsList)

    // Set isTemp flag
    if (tempClients.length > 0) {
      localStorage.setItem('isTemp', 'true');
    } else {
      localStorage.setItem('isTemp', 'false');
    }
  }

  categoryRouteGroupName(route: any, id: any) {
    // console.log('route', route)
    // console.log('id', id)
    // console.log('data', this.data)
    let type = 'legal'
    this.httpservice.setData(this.data);

    this.router.navigate([route], {
      queryParams: {
        type,
        highlight: id
      },
      // state: {
      //   data: this.data
      // }
    });
  }

  // Alert ts
  successResp(action: string) {
    if (action == 'yes') {
      this.successModel = false;
      if (this.selectedType == 'individual') {
        this.ClientType = 'entity';
      }
      else {
        this.ClientType = 'individual';
      }
    }
    this.onReset();
    this.onResetentity();
    this.entityClient.reset();
    this.tempClient.reset();
  }

  noResp(action: string) {
    if (action == 'no') {
      this.successModel = false;
      this.selectedType = this.selectedType;
    }
  }
  toggleType() {
    this.selectedType = this.selectedType === 'individual' ? 'entity' : 'individual';
  }

  //For cancel button dialog
  keyResp(action: string) {
    if (action == 'yes') {
      this.keyModel = false;
      this.searchText = '';
      this.tempList = false;
      this.showTempForm = false;
            
      if (this.selectedType == 'individual') {
        this.ClientType = 'entity';
      }
      else {
        this.ClientType = 'individual';
      }

      this.onReset();
      this.onResetentity();
      this.entityClient.reset();
      this.tempClient.reset();

      // this.submitted = false;
      // this.entitysubmitted = false;
      // this.clientsList = this.originalClientsList.filter((client: any) =>
      //   !this.selectedClients.includes(client)
      // ); // get back the client list
    }
  }

  nokeyResp(action: string) {
    if (action == 'no') {
      this.keyModel = false
    }
  }

  checkDuplicateTagType(index: number) {
    const currentValue = this.currentDocTags[index]?.tagtype?.trim().toLowerCase();

    if (!currentValue) return;

    const duplicateIndex = this.currentDocTags.findIndex(
      (item: any, i: number) =>
        i !== index &&
        item.tagtype?.trim().toLowerCase() === currentValue
    );

    if (duplicateIndex !== -1) {
      this.currentDocTags[index].tagtype = ''; // Remove duplicate text
      this.toast.error('Duplicate tag types are not allowed.');
    }
  }
} 